{
  "modelResources": {
    "library": "资源库",
    "select": "选择",
    "selectOrCreate": "选择或创建",
    "unavailable": "此模型暂不支持资源创建。",
    "elementMedia": "主体素材",
    "frontalImage": "正面图片（必填）",
    "otherImages": "其他参考图片（必填）",
    "elementVideo": "主体视频（必填）",
    "imageRequirements": "上传图片或粘贴可公开访问的图片链接。需 1 张正面图和 1～3 张不同角度或细节图；JPG / JPEG / PNG，每张不超过 10 MB，宽高均不小于 300 像素，宽高比 1:2.5～2.5:1。",
    "videoRequirements": "上传视频或粘贴可公开访问的视频链接。仅支持 1 段 MP4 / MOV，3～8 秒、1080P、16:9 或 9:16，不超过 200 MB；视频需为写实人形，有人声时会触发音色定制并绑定主体。",
    "create_element": "创建主体",
    "create_voice": "创建音色",
    "myResources": "我的资源",
    "officialResources": "官方资源",
    "empty": "暂无资源",
    "elements": "主体管理",
    "voices": "音色管理",
    "previewOnly": "当前暂不可用，可先查看参数。",
    "failed": "资源操作失败"
  },
  "voiceDesign": {
    "saveTitle": "保存为私有音色",
    "preview": "选择试听",
    "previewNumber": "试听 {{count}}",
    "name": "音色名称",
    "save": "保存音色",
    "saving": "正在保存…",
    "saveFailed": "音色保存失败。",
    "slotPrice": "{{amount}}，有效期 30 天。试听生成单独计费。",
    "priceUnavailable": "音色槽位价格暂不可用。",
    "expires": "到期时间：{{date}}",
    "loadFailed": "私有音色列表加载失败。"
  },
  "nativeStudio": {
    "path": "路径参数",
    "query": "查询参数",
    "body": "请求参数",
    "required": "请填写 {{field}}。",
    "invalidFiles": "{{field}} 需要选择本地文件。",
    "fileNotJson": "请通过文件控件选择 {{field}}，不要在 JSON 中填写文件地址。",
    "fileLimit": "{{field}} 最多支持 {{count}} 个文件。",
    "maxFiles": "最多 {{count}} 个文件",
    "scalar": "{{field}} 需要填写文本、数字或布尔值。",
    "invalidPath": "接口路径无效。",
    "saving": "正在读取结果并保存图片…",
    "readRetrying": "暂时无法读取图片记录，正在自动重试。原厂响应仍可在 JSON 中查看，请勿重复生成。",
    "saveFailed": "图片保存失败，原厂响应仍可在 JSON 中查看。"
  },
  "channelSupply": {
    "degraded": "降级",
    "form": "渠道供给设置",
    "saveFailed": "供给保存失败",
    "costLabel": "渠道成本价",
    "targetHelp": "渠道和上游模型 ID 决定实际请求目标。",
    "chooseChannel": "请选择兼容渠道",
    "channelLocked": "渠道在导入后不可切换；如需更换，请新增一份供给。",
    "compatibleChannels": "可选择 {{count}} 个渠道；接入前请确认渠道已开通此模型。",
    "noChannels": "暂无兼容渠道。",
    "upstreamId": "上游模型 ID",
    "upstreamIdPlaceholder": "渠道实际接受的 model",
    "maxActiveJobs": "该渠道模型的异步并发上限",
    "maxActiveJobsPlaceholder": "留空表示不限制",
    "maxActiveJobsHelp": "只限制这条渠道模型供给；渠道总上限仍同时生效。",
    "invalidMaxActiveJobs": "并发上限必须是大于 0 的整数",
    "channelInactive": "上游渠道当前为「{{status}}」，即使本供给保持启用也不会参与调度。",
    "coverage": "该渠道参与的公开协议（端点覆盖）",
    "coverageHelp": "选择该渠道实际支持的协议，并设置主备和权重。优先使用主线路；同级优先直通，再按权重分流。",
    "coverProtocol": "接入 {{protocol}}",
    "legacy": "历史协议 · 仅保留已有线路",
    "passthrough": "直通（passthrough）",
    "taskAdapter": "任务适配（task_adapter）",
    "bridge": "桥接（bridge）→ {{protocol}}",
    "providersOnly": "仅适用于 {{providers}}",
    "upstreamPath": "上游路径",
    "protocolPath": "{{protocol}} 上游路径",
    "pathPlaceholder": "相对 Base URL 的路径",
    "routeStatus": "线路状态",
    "protocolStatus": "{{protocol}} 线路状态",
    "protocolPrimary": "{{protocol}} 主线路",
    "weight": "权重",
    "protocolWeight": "{{protocol}} 权重",
    "directHelp": "声明上游直接支持，不经过平台桥接",
    "enabledAfterSave": "保存后启用",
    "notDeclared": "未声明",
    "noProtocols": "该模型暂无可接入的协议。",
    "mappingOnly": "供给已启用，但尚无启用的线路；请启用至少一条端点线路。",
    "primaryWarning": "每个端点只有一条主线路：保存后，「{{holders}}」在对应端点上的主线路会自动降为备用。",
    "costHelp": "内部成本用于销售价与毛利测算，可稍后单独维护。",
    "maintainCost": "同时维护内部成本价",
    "costSource": "成本依据",
    "costSourcePlaceholder": "合同、报价单或渠道说明",
    "costRules": "成本计费规则",
    "costRulesHelp": "每条规则对应一个计费条件；例如 Token 按每 1M、视频按每秒。复杂条件可在高级模式维护 JSON。",
    "saveHelp": "变更在保存后生效",
    "newSaveHelp": "保存后可继续调整供应线路与分流权重",
    "saving": "保存中…",
    "save": "保存供给"
  },
  "modelEndpoints": {
    "intro": "核对原厂参数定义，并查看平台公开端点与调用示例。",
    "nativeContract": "原厂协议与参数",
    "codeDefinition": "代码定义",
    "nativeContractHelp": "原厂请求与响应的参数定义，供接入核对与适配使用；只有列入公开端点的协议才可直接调用。",
    "channels": "{{count}} 个可用渠道",
    "addresses": "接口地址",
    "request": "请求",
    "stream": "流式音频",
    "officialDocumentation": "查看官方参数文档",
    "empty": "尚未配置公开端点"
  },
  "modelIdentity": {
    "intro": "查看模型名称、版本和公开 Model ID，维护别名及上架状态。",
    "legacyIntro": "此模型不在当前目录中，仅保留已有记录。",
    "edit": "编辑上架设置",
    "aliases": "Model ID 别名",
    "aliasesPlaceholder": "旧 ID, 简写 ID",
    "aliasesHelp": "每个别名都与主 Model ID 指向同一个模型，用于兼容旧 ID 或提供简写。",
    "aliasPlaceholder": "例如 old-model-id",
    "aliasItem": "Model ID 别名 {{index}}",
    "addAlias": "添加别名",
    "manageAliases": "管理别名",
    "removeAlias": "删除第 {{index}} 个别名",
    "recommendation": "推荐设置",
    "feature": "设为精选模型",
    "saveHelp": "保存别名与上架设置，不改变模型参数。",
    "saving": "保存中…",
    "saveFailed": "上架设置保存失败",
    "family": "产品线",
    "registryKey": "内部注册键",
    "summaryFallback": "{{model}}，支持{{operation}}。"
  },
  "adminModels": {
    "endpointLabels": {
      "托管任务": "Nexra Task API"
    },
    "description": "管理模型上架信息、协议参数、渠道和价格。",
    "search": "搜索模型",
    "searchPlaceholder": "公开 Model ID、别名、端点或开发者",
    "allChannels": "全部渠道",
    "noDeveloper": "未填写开发者/系列",
    "publicApi": "公开 API",
    "noEndpoints": "尚无公开端点",
    "aliasCount": "{{count}} 个别名",
    "typeCapability": "类型与能力",
    "supply": "渠道供给",
    "channelsCount": "{{count}} 条上游渠道",
    "moreChannels": "另有 {{count}} 条",
    "noChannels": "尚无渠道接入",
    "costCoverage": "已录成本 {{priced}}/{{total}}",
    "view": "查看维护",
    "empty": "没有匹配的模型",
    "page": "第 {{page}} 页 · 本页 {{count}} 条",
    "back": "← 返回模型目录",
    "openPublic": "在前台打开模型 ↗",
    "publicId": "公开 Model ID",
    "quickSettings": "模型快捷设置",
    "enable": "启用模型",
    "enableHelp": "允许模型接受调用；仍需可用的端点、渠道与计费配置。",
    "publish": "公开模型",
    "publicHelp": "控制模型的公开展示范围，不会自动启用模型。",
    "feature": "精选模型",
    "featureHelp": "设为精选；不会自动启用或公开模型。",
    "unfeatureHelp": "取消精选；不影响启用和公开设置。",
    "protocols": "公开端点协议",
    "protocolCount": "{{count}} 个模型声明的协议",
    "unconfigured": "未配置",
    "availabilityHelp": "控制台可调用数量根据端点、渠道、路由和有效销售价等配置计算，不代表上游实时可用性。",
    "apiReadiness": "API 可用性",
    "callableRatio": "{{callable}} / {{declared}} 个端点可调用",
    "nativeAccess": "原生接口",
    "taskAccess": "Nexra Task",
    "developerFact": "厂商：{{value}}",
    "typeFact": "类型：{{value}}",
    "versionFact": "版本：{{value}}",
    "familyFact": "系列：{{value}}",
    "currentPrices": "当前价格",
    "perPricingUnit": "每 {{unit}}",
    "morePriceRules": " · 另有 {{count}} 项",
    "requests30d": "近 30 天调用",
    "successRate": "成功率 {{value}}",
    "usageUnavailable": "调用统计暂不可用",
    "supplyChannels": "供货渠道",
    "noSupply": "暂无可调度渠道",
    "supplyReadiness": "供给与路由",
    "availableChannels": "{{count}} 个可供货渠道",
    "endpointCoverage": "已覆盖 {{covered}} / {{total}} 个端点",
    "commercialReadiness": "价格与成本",
    "salePriceActive": "公开售价已生效",
    "salePriceMissing": "未配置有效公开售价",
    "priceCoverage": "官方参考价 {{official}} 项 · 渠道成本 {{priced}}/{{total}}",
    "complete": "完整",
    "needsConfiguration": "需要补充配置",
    "readinessNavigation": "模型上线配置摘要",
    "openReadiness": "查看{{label}}配置",
    "disabled": "模型未启用",
    "callable": "控制台可调用 {{count}} 个端点",
    "noCallable": "控制台暂无可调用端点",
    "upstream": "上游供货渠道",
    "saveFailed": "模型配置保存失败",
    "loading": "正在加载模型配置…"
  },
  "officialPrice": {
    "validity": "价格有效期",
    "ongoing": "长期有效",
    "promotion": "限时促销",
    "ongoingHelp": "不设结束日期",
    "promotionHelp": "需设置结束日期",
    "endsAt": "促销结束时间",
    "endsAtHelp": "到达该时间后，此官方限时价格不再生效。",
    "saveFailed": "保存失败",
    "description": "维护当前官方参考价；保存后立即生效。",
    "title": "维护官方价格",
    "saveHelp": "价格保存后立即用于后续报价。",
    "operation": "适用能力",
    "source": "官方来源或依据链接",
    "sourcePlaceholder": "https://... 或资料编号",
    "rulesHelp": "每条规则对应一个计费条件；例如 Token 按每 1M、视频按每秒。复杂条件可在高级模式维护 JSON。",
    "promotionFooter": "限时促销结束后，当前价格会自动失效。",
    "ongoingFooter": "长期有效，不设置结束日期。",
    "saving": "正在保存…",
    "save": "保存官方价格",
    "invalidObjectJson": "{{label}} 的 JSON 格式不正确：{{detail}}",
    "parseFailed": "解析失败",
    "objectRequired": "{{label}} 必须是 JSON 对象"
  },
  "pricingEditor": {
    "invalidJson": "计费规则 JSON 格式不正确，请在下方修复或重新粘贴。",
    "missingRates": "计费规则缺少 rates 数组，请在下方修复或重新粘贴。",
    "invalidPrice": "单价需为非负数字",
    "invalidUnit": "计价单位需为正整数",
    "json": "计费规则 JSON",
    "empty": "暂无计费规则，点击下方添加。",
    "rule": "规则 {{index}}",
    "duplicateRule": "规则 {{index}} · 条件与其他规则重复",
    "copyRule": "复制规则 {{index}}",
    "removeRule": "删除规则 {{index}}",
    "metricLabel": "规则 {{index}} 的计费指标",
    "priceLabel": "规则 {{index}} 的单价",
    "unitLabel": "规则 {{index}} 的计价单位",
    "rounding": "计费方式",
    "roundingLabel": "规则 {{index}} 的计费方式",
    "proportional": "按实际用量（不取整）",
    "unknownMetric": "{{metric}}（未收录）",
    "dimensionLabel": "规则 {{index}} 条件 {{condition}} 的维度",
    "valueLabel": "规则 {{index}} 条件 {{condition}} 的值",
    "removeCondition": "删除规则 {{index}} 的条件 {{condition}}",
    "addCondition": "添加条件",
    "addConditionLabel": "为规则 {{index}} 添加条件",
    "addRule": "添加计费规则",
    "scalarHelp": "数字和 null 条件保留原类型，请在高级 JSON 中修改其值。",
    "unitHelp": "计价单位：tokens 类常用 1000000（每 1M tokens）；图片 / 视频 / 按次计费常用 1。",
    "advanced": "高级 · 直接编辑 JSON",
    "jsonHelp": "粘贴整段规则并解析通过后，上方表单会自动回填。"
  },
  "priceReference": {
    "allManufacturers": "全部厂商",
    "usd": "美元",
    "cny": "人民币",
    "manufacturer": "厂商",
    "officialList": "官方参考价",
    "allModels": "全部模型",
    "emptyModels": "没有匹配的模型",
    "title": "模型价格参考",
    "search": "搜索模型",
    "searchLabel": "搜索模型价格",
    "searchPlaceholder": "输入名称或公开模型 ID",
    "lookup": "查看模型价格",
    "lookupHelp": "查看基础销售价、渠道成本和官方参考价。实际费用受调用时的单价及用户折扣影响；当天费用以每日明细为准。",
    "select": "请选择模型",
    "loading": "正在读取模型价格…",
    "failed": "价格读取失败，请刷新重试。",
    "modelEmpty": "此模型暂无当前生效价格。",
    "lastRead": "上次成功读取价格：{{date}} UTC",
    "notRead": "尚未读取价格",
    "configure": "查看模型配置与价格依据 →",
    "empty": "暂无当前生效价格",
    "official": "参考价",
    "cost": "渠道价",
    "multiple": "销售倍率",
    "equivalent": "人民币等值",
    "saleHelp": "按渠道价币种展示可比销售单价；无渠道价时参考官方币种。换算项标记为折合，实际计费仍使用价格配置的原币种。",
    "equivalentHelp": "美元可比销售单价的人民币等值，仅供比较；实际计费使用原币种。",
    "equivalentFx": "人民币等值按 1 USD = {{rate}} CNY 换算，仅供价格比较。",
    "generalOperation": "通用能力",
    "generalChannel": "通用渠道",
    "invalid": "计价规则无法解析",
    "invalidHelp": "计价规则无法解析，请查看模型配置",
    "special": "特殊规则",
    "converted": "折合",
    "currencyUnit": "币种：{{currency}} · 每 {{unit}}",
    "ceil": "向上取整",
    "proportional": "按实际数量",
    "included": "含 {{quantity}} {{unit}}",
    "original": "原始单价：{{value}}",
    "currencyHelp": "上游币种：{{currency}} · 等值按定价策略汇率：1 USD = {{rate}} CNY；仅供当前价格比较，实际计费保留原币种及结算时绑定的价格。",
    "effectiveFrom": "生效时间：{{date}} UTC",
    "effectiveTo": "失效时间：{{date}} UTC",
    "noMultiple": "倍率 —",
    "multipleValue": "{{value}}倍",
    "noMultipleHelp": "缺少唯一可比的渠道价、有效汇率，或渠道价为 0；不同取整方式或包含量不直接计算倍率。",
    "multipleHelp": "销售价 ÷ 本行渠道价；相同单位、计费条件及规则下比较，最多保留 4 位小数。此值不代表毛利率。",
    "multipleFx": "按定价策略汇率 1 USD = {{rate}} CNY 换算。",
    "condition": "{{label}}：{{value}}",
    "has_reference_image_true": "有参考图",
    "has_reference_image_false": "无参考图",
    "has_input_video_true": "有输入视频",
    "has_input_video_false": "无输入视频",
    "layer_decomposition_true": "分层",
    "layer_decomposition_false": "不分层",
    "with_audio_true": "有音频",
    "with_audio_false": "无音频"
  },
  "pricingPreview": {
    "discount": "{{value}}折",
    "backupCost": "备用渠道成本",
    "metric": "计费项",
    "condition": "条件",
    "official": "官方价",
    "primaryCost": "主渠道成本",
    "sale": "销售价",
    "vsOfficial": "较官方",
    "needsFx": "需汇率",
    "perUnit": "每 {{unit}}",
    "editOfficial": "维护官方价",
    "addOfficial": "录入官方价",
    "currency": "展示币种",
    "multiplier": "销售倍率",
    "multiplierSlider": "销售价加价倍率滑块",
    "multiplierInput": "销售价加价倍率",
    "quick": "快捷倍率",
    "settings": "设置快捷倍率",
    "settingsHelp": "快捷倍率（当前预览，不保存）",
    "preset": "快捷 {{index}}",
    "presetInput": "快捷倍率 {{index}}",
    "margin": "毛利率",
    "empty": "该能力尚无已发布的官方价格。",
    "fxHelp": "较官方按定价策略汇率 {{rate}} 将售价折成 {{currency}} 后比较。",
    "previewHelp": "价格直接读取当前销售价；调整倍率只用于当前预览，不会写入实际计费。",
    "missingFxHelp": "销售计费为 CNY；跨币种售价请在定价策略中配置汇率并发布。",
    "comparisonHelp": "较官方：负值低于官方，正值高于官方。",
    "belowCost": "售价低于成本",
    "displayedCurrency": "展示币种：{{currency}}",
    "context": "上下文 {{value}}"
  },
  "adminPricing": {
    "loadFailed": "定价策略读取失败，请刷新重试。",
    "managementTitle": "定价管理",
    "adjust": "调整策略",
    "title": "全局销售定价策略",
    "current": "当前线上策略：",
    "configuration": "平台基准销售倍率配置",
    "saleFormula": "人民币销售价 = 折算后的主渠道成本 × 销售倍率",
    "rateLabel": "美元成本折算汇率",
    "ratePlaceholder": "运营采用的汇率",
    "publishRate": "保存并发布汇率",
    "presets": "快捷倍率预设",
    "multiplierLabel": "默认销售倍率",
    "multiplierSlider": "调整销售倍率",
    "atCost": "1.00×（售价等于采购成本）",
    "halfMargin": "2.00×（毛利率约 50%）",
    "margin": "按采购成本估算的毛利率",
    "marginFormula": "公式：1 − (1 / 倍率)",
    "publishMultiplier": "保存并发布销售倍率",
    "confirmRate": "确认发布汇率？",
    "confirmMultiplier": "确认发布销售倍率？",
    "confirmHelp": "系统将按销售倍率 {{multiplier}}× 重算主渠道已发布采购成本对应的销售价格，保存后更新当前价格。",
    "targetMultiplier": "目标销售倍率",
    "exchangeRate": "美元折算汇率",
    "scope": "影响范围",
    "scopeValue": "主渠道具有已发布采购成本的模型计费项",
    "notConfigured": "未配置",
    "confirm": "确认发布生效",
    "ratePublished": "汇率已发布",
    "multiplierPublished": "销售倍率已发布",
    "publishedSummary": "按 {{multiplier}}× 重算并发布 {{count}} 个销售价"
  },
  "adminWallets": {
    "apply": "应用筛选",
    "frozen": "钱包已冻结",
    "closed": "已关闭",
    "title": "钱包与账务",
    "total": "全部人民币钱包总余额",
    "search": "搜索钱包用户",
    "balance": "钱包总余额",
    "available": "可用余额",
    "updatedAt": "更新时间",
    "loading": "正在加载钱包列表…",
    "empty": "没有匹配的钱包",
    "currentBalance": "当前余额",
    "afterBalance": "入账后余额",
    "balanceLimit": "入账后余额超过钱包上限，请减少金额。",
    "offlineHint": "入账前请确认线下收款（对公转账 / 微信 / 支付宝）。",
    "summaryDetail": "请求预占 {{reserved}} · {{count}} 个钱包",
    "pageCount": "本页 {{count}} 个钱包",
    "creditDescription": "确认线下收款后，将金额记入 {{email}} 的 {{currency}} 钱包，并生成正式充值与流水记录。"
  },
  "adminOperations": {
    "failed": "操作失败",
    "tryAgain": "请稍后重试"
  },
  "adminStorage": {
    "taskApi": "Task API",
    "nativeApi": "Native API",
    "loadFailed": "存储明细读取失败，请刷新重试",
    "allDispositions": "全部处置",
    "stored": "已存储",
    "forwarded": "直接转发",
    "pending": "待回补",
    "failed": "落库失败",
    "allKinds": "全部类型",
    "document": "文档",
    "archive": "压缩包",
    "lastDay": "近 24 小时",
    "lastWeek": "近 7 天",
    "lastMonth": "近 30 天",
    "upload": "用户上传",
    "imported": "导入",
    "model": "模型",
    "kindPath": "类型 / 路径",
    "surface": "线路",
    "location": "存储位置",
    "size": "大小",
    "disposition": "处置",
    "reference": "关联对象",
    "note": "备注",
    "title": "存储明细",
    "back": "← 调用记录",
    "languageGateway": "语言网关（chat / responses / messages / gemini）",
    "languagePolicy": "：响应体直接转发，仅保留前 64KB 预览用于排障。",
    "nativeName": "Native API（native）",
    "nativePolicy": "：响应体直接转发，不归档媒体、不改写资源链接；调用日志保留有限预览。",
    "taskName": "Task API（nexra-task）",
    "taskPolicy": "：任务输入与输出媒体均存储，失败后标记待回补。",
    "publicDomain": "公网域",
    "objectLimit": "单对象上限",
    "actualLocation": "每条记录的实际位置以表格为准。",
    "policyTitle": "响应处置与当前存储",
    "policySummary": "语言网关直转 · Native API 不归档媒体、不改写资源链接 · Task API 媒体存储",
    "unconfigured": "存储未配置",
    "loadingConfig": "正在读取存储配置…",
    "anomalies": "异常",
    "loading": "正在查询存储中转记录…",
    "empty": "当前筛选没有存储中转记录",
    "end": "没有更多数据",
    "filterDisposition": "处置筛选",
    "mediaKind": "媒体类型",
    "filterKind": "媒体类型筛选",
    "window": "统计窗口",
    "apply": "应用筛选",
    "detailDescription": "存储中转明细：该响应体/媒体对象的存储去向与持久化证据。",
    "detailEyebrow": "存储中转",
    "internalId": "内部 ID",
    "source": "线路来源",
    "objectStatus": "对象状态",
    "path": "请求路径",
    "httpStream": "HTTP / 流式",
    "streaming": "流式",
    "nonStreaming": "非流式",
    "storageProvider": "存储提供方",
    "bucket": "桶",
    "objectKey": "对象键",
    "publicUrl": "公网 URL",
    "notStored": "未落存储说明",
    "nativeNotStored": "该 Native API 调用没有媒体归档记录；原生代理不归档媒体、不改写资源链接。",
    "fullDetails": "在调用记录中查看完整详情 →",
    "persistenceError": "持久化错误",
    "storedDetail": "窗口内新增对象 · {{size}}",
    "forwardedDetail": "Native {{native}} · 语言网关 {{language}}",
    "issuesDetail": "待回补 {{pending}} · 落库失败 {{failed}}",
    "assetTitle": "媒体资产 {{id}}",
    "requestTitle": "代理请求 {{id}}",
    "pageCount": "本页 {{count}} 行",
    "cursorPage": " · 游标翻页中",
    "windowHours": " · 统计窗口 {{count}} 小时"
  },
  "adminErrorReport": {
    "requestShare": "占全部请求",
    "nonErrorShare": "非错误占比",
    "periodScope": "按请求接收时间统计：包含开始时间，不包含结束时间。",
    "cancellationScope": "取消单独统计，不计入调用错误。",
    "nonErrorRequests": "非错误请求",
    "compareFromZero": "较上一区间：由 0 增至 {{count}}",
    "comparePoints": "较上一区间 {{direction}} {{value}} 个百分点",
    "comparePercent": "较上一区间 {{direction}} {{value}}%",
    "rankHelp": "按错误率从高到低排列；相同错误率按错误数量排列。",
    "statusDistribution": "异常状态分布",
    "statusDistributionHelp": "占比以失败、拒绝、交付失败和取消的总数为基数；取消不计入调用错误率。 小占比扇区为便于辨识已放大，实际占比以右侧数值为准。",
    "trendHint": "按 UTC 日期统计错误数量与占全部请求的比例，不包含取消。",
    "distributionHint": "展示当前筛选范围内的异常数量和占比。",
    "dimensionDistribution": "异常维度分布",
    "other": "其他（{{count}} 项）",
    "tab": "异常概览",
    "title": "异常概览",
    "failedRequests": "调用错误数",
    "failedHelp": "包含执行失败、拒绝和交付失败；取消单独统计",
    "failureRate": "最终调用错误率",
    "trend": "错误趋势",
    "categories": "计费异常类型",
    "share": "占比",
    "firstOccurrence": "首次发生",
    "lastOccurrence": "最近发生",
    "scopeHelp": "查看错误原因与受影响的模型、渠道，进入明细排查。",
    "cancelled": "取消请求",
    "billingHelp": "与调用错误独立统计，同一请求可能同时存在两类问题",
    "requestBase": "占当前范围内 {{count}} 次请求",
    "normalCalls": "共 {{total}} 次 · 正常 {{normal}} 次",
    "normalRate": "正常率 {{rate}}",
    "cancelledShare": "占全部请求 {{rate}}",
    "viewRecords": "查看记录",
    "errorCode": "错误码",
    "errorCodeSearch": "输入完整错误码",
    "missingCode": "未记录错误码",
    "clearMissingCode": "未记录错误码 · 清除筛选",
    "unattributed": "未分配",
    "reasons": "错误原因排行",
    "topTen": "展示错误数量最多的前 10 项；占比以全部调用错误为基数。",
    "modelRank": "异常模型 · 前 10 项",
    "channelRank": "异常渠道 · 前 10 项",
    "emptyErrors": "当前筛选没有调用错误",
    "emptyCalls": "当前筛选没有调用异常",
    "allErrors": "查看全部调用错误",
    "allBilling": "查看全部计费异常",
    "invalidWindow": "统计区间不能超过 366 天"
  },
  "adminFinance": {
    "shortcutDescription": "销售额、成本与毛利",
    "title": "财务统计",
    "records": "费用记录",
    "overview": "财务概览",
    "summary": "成本分析",
    "usage": "用量",
    "knownCost": "已知成本",
    "incompleteCost": "成本待补全",
    "settledCount": "已结算 {{count}} 笔",
    "salesChange": "销售额变化额",
    "salesChangeRate": "销售额变化率",
    "salesChangeHint": "与上一段等长时间区间的全部已结算人民币销售额比较。变化额＝本期销售额－上期销售额；变化率＝变化额÷上期销售额。",
    "noSalesComparison": "暂无可比销售额",
    "zeroSalesComparison": "上期销售额为 0，变化率不适用",
    "coverageRate": "覆盖率",
    "coverageRateHint": "成本已覆盖笔数 ÷ 总笔数，与覆盖笔数使用相同统计范围。",
    "coverageCount": "覆盖笔数",
    "coveredGross": "已覆盖成本的毛利",
    "coveredProfitHint": "仅显示覆盖成本的毛利",
    "coveredMarginHint": "按成本已覆盖记录的收入计算",
    "profitGrowth": "毛利变化额",
    "profitGrowthRate": "毛利变化率",
    "previousPeriod": "较上一等长区间",
    "noComparison": "暂无可比毛利",
    "zeroComparison": "上期毛利为 0，变动率不适用",
    "growthHint": "与上一段等长时间区间比较。毛利变化额＝本期毛利－上期毛利；毛利变化率＝变动额÷上期毛利绝对值。仅比较成本已覆盖部分，覆盖情况变化也会影响结果。",
    "settledScope": "已结算 · 人民币",
    "details": {
      "title": "{{name}} · 计费明细",
      "names": {
        "product": "产品",
        "kind": "模型用途"
      },
      "search": {
        "product": "搜索产品名称",
        "model": "搜索模型名称或 Model ID",
        "channel": "搜索提供商或渠道名称"
      },
      "complete": "成本完整",
      "missingCost": "缺成本",
      "missingRate": "缺汇率",
      "allCoverage": "全部成本状态",
      "coverage": "成本完整性",
      "settledRequests": "已结算笔数",
      "exportRows": "当前已提交的搜索和筛选结果，共 {{count}} 条。金额单位：人民币元。",
      "allSeries": "全部模型系列",
      "allKinds": "全部模型用途",
      "startDate": "起始日期（UTC）",
      "endDate": "结束日期（UTC）",
      "dateRecords": "日期记录",
      "allDates": "全部日期",
      "activeDates": "仅有结算的日期",
      "empty": "没有符合条件的明细",
      "total": "当前筛选结果合计 · {{count}} 条"
    },
    "chartTitles": {
      "product": "按产品收入与成本",
      "kind": "按模型用途收入与成本",
      "model": "按具体模型收入与成本",
      "channel": "按渠道收入与成本"
    },
    "products": {
      "vibepaper": "VibePaper",
      "starcut": "StarCut",
      "starcat": "StarCat",
      "unattributed": "未标注产品"
    },
    "kinds": {
      "language": "文字",
      "image": "图片",
      "video": "视频",
      "audio": "音频",
      "world": "世界模型",
      "embedding": "向量",
      "unknown": "未标注用途"
    },
    "modelFamily": "模型系列",
    "unattributedFamily": "未标注系列",
    "unattributedModel": "未标注模型",
    "unattributedChannel": "未标注渠道",
    "modelComparisonHint": "当前筛选区间内所选系列各具体模型的已结算人民币收入与已知成本；毛利率按成本已覆盖记录的毛利与收入计算，成本缺失不视为零。",
    "comparisonHint": "当前筛选区间内已结算的人民币收入与已知成本；毛利率按成本已覆盖记录的毛利与收入计算。所有分组均完整展示。",
    "productAttributionHint": "产品暂按 API Key 的产品名称标签识别，未标注记录保留为未标注产品；成本缺失不视为零。",
    "chartKeyboard": "{{title}}，使用方向键浏览分组，Home 和 End 跳转首尾，Escape 关闭提示"
  },
  "adminUsage": {
    "userTextSearch": "用户 ID、邮箱或用户名",
    "changeDirection": {
      "increase": "增加",
      "decrease": "减少",
      "unchanged": "无变化"
    },
    "modelActions": {
      "details": "模型详情",
      "noModel": "此汇总行不对应单个模型"
    },
    "requestGrowth": "请求增长数",
    "requestGrowthRate": "请求增长率",
    "requestGrowthHint": "与上一段等长时间区间比较。请求增长数＝本期请求数－上期请求数；请求增长率＝请求增长数÷上期请求数。上期为 0 时不显示增长率。",
    "noRequestComparison": "暂无可比请求数据",
    "zeroRequestComparison": "上期请求数为 0，增长率不适用",

    "failedRequests": "请求失败数",
    "productRequestsHint": "按 API Key 名称中的产品标签归属并统计全部请求，未标注的记录保留为未标注产品。",
    "kindRequestsHint": "按模型目录中的用途汇总全部请求次数。",
    "modelSeriesDistributionHint": "按模型系列汇总请求次数，例如 Gemini 包含该系列的全部模型；点击系列可查看相关模型明细。",
    "otherModelSeries": "其他系列（{{count}}）",
    "productRequestCounts": "产品应用调用次数",
    "kindRequestCounts": "模型用途调用次数",
    "channelDistribution": "渠道调用分布",
    "channelDistributionHint": "按请求次数展示各渠道的调用占比，点击渠道可查看明细。",
    "modelRequestCounts": "模型调用次数",
    "channelRequestCounts": "渠道调用次数",
    "requestComparisonHint": "按请求次数降序展示，点击可查看明细。",

    "dailyCalls": "每日调用",
    "dailyCallsHint": "按天对比请求总数与请求成功数；失败数仅在悬浮提示中显示。",
    "successfulRequests": "请求成功数",
    "requestSuccessRate": "请求成功率",
    "statisticsDetails": "用量明细",
    "statisticsDetailsTitle": "{{name}} · 用量明细",
    "uncoveredRequests": "未覆盖数",
    "coveredRequests": "覆盖数",

    "providerId": "提供商 ID",
    "requestCapability": "本次调用",
    "inputFeatures": {
      "text": "提示词",
      "image": "图片输入",
      "video": "视频输入",
      "audio": "音频输入",
      "first_frame": "首帧",
      "last_frame": "尾帧",
      "reference_image": "参考图",
      "reference_video": "参考视频",
      "reference_audio": "参考音频"
    },
    "totalRequests": "总请求",
    "bucketHint": "当前时间桶内收到的全部请求。",
    "successHint": "接口调用成功或异步任务已受理；任务受理不代表最终生成成功，也不代表已计费。",
    "failureHint": "失败、取消或拒绝的请求；不同于计费失败。",
    "billedHint": "存在成功结算记录；已退款记录也归此类，金额仅计成功结算。",
    "unsettledHint": "已有用量记录，尚未形成成功结算记录；持续存在时查看请求明细。",
    "billingFailedHint": "存在失败的结算记录；查看计费异常定位原因。",
    "unpricedHint": "请求成功但未匹配有效销售价；核对模型和操作的定价配置。",
    "usageMissingHint": "请求已经成功，但没有记录到用量；属于异常，建议排查用量采集。",
    "usageNotExpectedHint": "请求没成功（拒绝、失败、取消，还在执行中），本来就不会产生用量，不是异常。",
    "otherRequests": "其他请求",
    "emptyRequests": "当前筛选没有请求数据",
    "modelNameUnavailable": "模型名称不可用",
    "modelDistribution": "模型调用分布",
    "modelDistributionHint": "按调用量从高到低由红色过渡到冷色；其他模型合计为灰色。点击模型扇区或名称查看明细。",
    "ratingDistribution": "计费状态分布",
    "ratingDistributionHint": "环形图显示六类互斥计费状态；占比以当前筛选的全部请求为分母，点击扇区或状态查看明细。 小占比扇区为便于辨识已放大，实际占比以右侧数值为准。",
    "longDateRange": "日期跨度超过 500 天，图表与表格仅列有请求日期；收窄时间范围可查看连续每日数据。",
    "noDates": "暂无日期",
    "usageHit": "有用量记录",
    "prevPeriod": "上一周期",
    "nextPeriod": "下一周期",
    "earlierDates": "更早日期",
    "laterDates": "更近日期",
    "noSettlements": "当前筛选没有成功结算金额；每日表保留请求数据。",
    "dailyDetailsHint": "日期倒序，每页最多 30 天；经营金额统一为人民币，仅包含成功结算记录，不含已退款或失败结算。采购原币金额与冻结汇率保留在调用明细和导出中。",
    "dailyDetails": "每日费用明细",
    "utcDateHint": "按请求接收日期以 UTC 统计。",
    "dailyRequestsHint": "当天收到的全部请求，包含尚未结束的请求。",
    "dailySuccessHint": "按当天接收的请求统计实际成功数；异步任务须完成执行与交付，仅受理不算成功。",
    "dailyFailedHint": "当天未实际成功的请求数。",
    "failedTasks": "失败任务",
    "dailyBilledHint": "存在成功结算记录的请求；已退款记录也归为已计费，但不计入经营金额。",
    "dailyInputHint": "仅汇总已计量的输入 Token；缺失显示 —，不补 0。",
    "dailyOutputHint": "仅汇总已计量的输出 Token；缺失显示 —，不补 0。",
    "dailySalesHint": "成功结算的人民币销售额，不含已退款或失败结算。",
    "dailyCostHint": "按请求冻结汇率折算的人民币采购成本；缺成本或汇率的记录不补 0。",
    "dailyGrossHint": "人民币销售额减采购成本；缺成本或汇率的请求不计入，成本不完整时仅为部分毛利。",
    "grossCny": "毛利",
    "dailyMarginHint": "人民币毛利 ÷ 销售额；销售额为 0 或成本不完整时显示 —。",
    "previousDatePage": "前一页日期",
    "nextDatePage": "后一页日期",
    "dualAxisHint": "请求数使用左轴，柱形表示；Token 使用右轴，折线表示。两侧独立刻度，不能按高度直接比较。",
    "tokenAxisHint": "输入和输出 Token 使用右轴刻度，仅汇总已计量值，缺失不补 0。",
    "mixedChart": "柱形与折线组合图",
    "barChart": "柱状图",
    "emptyDaily": "当前筛选没有每日数据",
    "inputLineHint": "仅汇总已计量的输入 Token，缺失显示 —，不补 0。",
    "outputLineHint": "仅汇总已计量的输出 Token，缺失显示 —，不补 0。",
    "dailyUsage": "每日用量",
    "requestAxis": "请求数（次）",
    "tokenAxis": "Token 数",
    "dailyUsageHint": "按请求接收日期统计 · 总请求包含未结束请求 · Token 仅汇总已计量值，缺失显示 —，不补 0",
    "dailyFinance": "每日收入与成本（人民币）",
    "dailyFinanceHint": "人民币经营口径 · 销售额与按冻结汇率折算的采购成本 · 仅包含成功结算记录",
    "comparePrev": "较上一区间",
    "dailyPeakLabel": "峰值",
    "dailyPeakSuffix": "（{{day}}）",
    "otherModels": "其他模型（{{count}}）",
    "otherChannels": "其他渠道（{{count}}）",
    "viewAllInSummary": "在用量汇总中查看全部",
    "viewModel": "查看 {{model}} 的请求明细 · {{id}}",
    "requestsCount": "{{count}} 次",
    "seriesCount": "{{label}} {{count}} 次",
    "leftAxis": "左轴：{{unit}}",
    "rightAxis": "右轴：{{unit}}",
    "chartAria": "{{title}}{{kind}}，按日期从早到晚排列",
    "chartType": "图表类型",
    "chartBar": "柱状",
    "chartArea": "面积",
    "amountAxis": "金额（{{currency}}）",
    "datePages": "本批 {{days}} 天 · 第 {{page}} / {{pages}} 页",
    "overview": "用量概览",
    "summary": "用量汇总",
    "details": "计费明细",
    "anomalies": "计费异常",
    "minute": "分钟",
    "hour": "小时",
    "day": "天",
    "month": "月",
    "user": "用户",
    "channel": "渠道",
    "model": "模型",
    "operation": "操作",
    "billed": "已计费",
    "unsettled": "未结算",
    "billingFailed": "计费失败",
    "unpriced": "未定价",
    "usageMissing": "成功但没用量",
    "usageNotExpected": "请求没成功",
    "normalized": "已标准化",
    "partial": "部分标准化",
    "invalid": "标准化失败",
    "missing": "无用量记录",
    "dimensionMismatch": "维度不匹配",
    "settlementFailed": "结算失败",
    "userId": "用户 ID",
    "userSearch": "邮箱、用户名或用户 ID",
    "keySearch": "Key 名称、前缀或 ID",
    "providerSearch": "提供商名称或 ID",
    "channelId": "渠道 ID",
    "channelSearch": "渠道名称或 ID",
    "modelId": "模型 ID",
    "modelSearch": "模型名称、公开 ID 或内部 ID",
    "operationSearch": "操作名称",
    "financialHint": "仅汇总成功结算记录；销售额与成本均按结算时冻结的汇率以人民币呈现，原币成本保留在请求明细和导出中。",
    "financialMetrics": "人民币经营指标",
    "sales": "销售额",
    "cost": "成本",
    "grossHint": "人民币销售额减去已折算人民币成本；成本或汇率缺失的请求不计入毛利。",
    "gross": "毛利",
    "marginHint": "人民币毛利 ÷ 人民币销售额；销售额为 0 或成本不完整时不显示。",
    "margin": "毛利率",
    "coverageHint": "成功结算记录中，具有人民币成本的记录数；缺成本或汇率的记录不补 0，成本不完整时不显示毛利率。",
    "costCoverage": "成本覆盖",
    "selectedFilter": "已选筛选值",
    "unconfirmedFilter": "请从下拉列表选择匹配项，或清空尚未确认的搜索内容",
    "invalidWindow": "开始时间必须早于结束时间（[start, end) 半开区间）",
    "billing": "计费",
    "normalization": "标准化",
    "supplierModel": "供应商 / 模型",
    "upstreamProvider": "上游供应商",
    "unknownModel": "未知模型",
    "loadingName": "名称加载中…",
    "requests": "请求数",
    "succeeded": "实际成功",
    "failed": "失败",
    "tokens": "Token 用量",
    "usageCoverage": "计量覆盖",
    "ratingStatus": "计费状态",
    "amounts": "费用（人民币）",
    "received": "接收时间",
    "request": "请求",
    "callOperation": "调用操作",
    "providerModel": "提供商 / 上游模型",
    "status": "状态",
    "duration": "耗时",
    "salesCny": "销售额",
    "costCny": "成本",
    "notConverted": "— · 未折算",
    "viewDetails": "查看详情",
    "title": "用量统计",
    "records": "用量记录",
    "callRecords": "调用记录",
    "refreshing": "刷新中…",
    "startLocal": "开始时间（本地时区输入）",
    "endLocal": "结束时间（本地时区输入）",
    "quickRange": "快捷范围",
    "today": "今天",
    "lastDay": "24 小时",
    "apply": "应用筛选",
    "summaryGranularity": "时间粒度（汇总视图）",
    "granularity": "时间粒度",
    "noBuckets": "不按时间分桶",
    "summaryDimension": "汇总维度",
    "ratingSearch": "计费状态",
    "normalizationStatus": "标准化状态",
    "normalizationSearch": "标准化状态",
    "loadingFresh": "正在读取最新用量与费用…",
    "loadingDaily": "正在汇总每日用量与费用…",
    "partialDates": "日期分组较多，每日用量、费用图与每日表展示当前批次；请翻页或收窄时间范围，避免将部分数据作为全区间合计。",
    "previousDates": "上一批日期",
    "nextDates": "下一批日期",
    "loadingSummary": "正在聚合用量…",
    "loadFailed": "读取失败，请刷新重试",
    "emptySummary": "当前筛选没有可聚合的请求",
    "loadingDetails": "正在查询计费明细…",
    "emptyDetails": "当前筛选没有计费明细",
    "cursorPage": "· 游标翻页中",
    "next": "下一页 →",
    "noMore": "没有更多数据",
    "requestVolume": "请求量",
    "successRate": "实际成功率",
    "viewFailedCalls": "查看失败调用",
    "successRateHint": "按请求或任务最终结果统计；后台保存结果的任务须完成交付才算成功。全部请求包含失败、拒绝、取消和未完成请求。",
    "usageCoverageRate": "计量覆盖率",
    "usageCoverageHint": "有用量记录的请求 ÷ 全部请求；没有用量记录不等于计费异常。失败和缺用量先查请求明细。",
    "billedRate": "已计费率",
    "billedRateHint": "已计费请求 ÷ 全部请求；存在成功结算记录即归为已计费，已退款记录也归此类。结算问题查看计费异常。",
    "unfinished": "未结束请求",
    "unfinishedHint": "尚未完成执行或交付的请求，包括已受理、排队、执行中和等待结果保存。",
    "viewAnomalies": "查看异常原因 →",
    "noAnomalies": "当前区间无计费异常",
    "inputTokensHint": "仅汇总已计量的输入 Token，缺失不补 0；图片、音视频等不按 Token 折算。",
    "inputTokens": "输入 Token",
    "outputTokensHint": "仅汇总已计量的输出 Token，缺失不补 0；图片、音视频等不按 Token 折算。",
    "outputTokens": "输出 Token",
    "tokenRequestsHint": "至少具有一项 Token 计量值的请求数量；不代表所有请求或所有模态的用量。",
    "tokenRequests": "含 Token 计量的请求",
    "tokenRequestsShort": "计量请求",
    "loadingTrend": "正在加载请求趋势…",
    "category": "类别",
    "quantity": "数量",
    "dimensionId": "维度 ID",
    "anomalyHint": "五类异常互斥，优先级为结算失败、标准化失败、未定价、成功但没用量、维度不匹配。成功但没用量仅统计成功请求，失败请求不会产生用量、不计入。",
    "anomalyCategory": "异常类别",
    "breakdown": "按维度拆分：",
    "breakdownDimension": "异常拆分维度",
    "noBreakdown": "不拆分",
    "emptyBreakdown": "该维度没有异常拆分数据",
    "loadingAnomalies": "正在查询计费异常…",
    "emptyAnomalies": "当前筛选没有计费异常",
    "upstreamModel": "上游模型",
    "reason": "原因",
    "missingRate": " · 缺汇率 {{count}}",
    "missingCosts": " · 缺成本 {{count}}",
    "nameUnavailable": "{{group}}名称不可用",
    "days": "{{count}} 天",
    "ratingCounts": "已计费 {{billed}} · 未结算 {{unsettled}}",
    "coverageCounts": "成本覆盖 {{reported}} / {{total}}",
    "moreFilters": "更多筛选",
    "pageCount": "本页 {{count}} 行",
    "missingCoverage": "缺成本 {{cost}} · 缺汇率 {{rate}}",
    "successCount": "实际成功 {{count}}",
    "failedCount": "失败 {{count}}",
    "outputCount": "输出 {{count}}",
    "inputCount": "输入 {{count}}",
    "missingCount": "缺失 {{count}}",
    "costAmount": "成本 {{amount}}",
    "historicalAmount": "历史原币 {{currency}} {{amount}}",
    "viewLabel": "统计视图",
    "dailySuccessTrend": "每日成功率趋势",
    "advancedFilters": "高级筛选",
    "modelComparison": "同类型模型对比",
    "modelType": "模型类型",
    "requestSource": "请求来源",
    "executionFilters": "执行条件",
    "billingFilters": "计费状态",
    "modelKindCount": "{{kind}} · {{count}}",
    "modelKinds": {
      "language": "文本",
      "image": "图片",
      "video": "视频",
      "audio": "音频",
      "other": "其他 / 未分类"
    },
    "channelComparison": "渠道成功率",
    "unattributed": "未归属",
    "anomalyCount": "计费异常 · {{count}}",
    "failureReasons": "失败原因分类",
    "failureReasonsHint": "按调用记录中的实际错误码展示前 10 项，剩余项合并；缺失错误码单列。此处不受计费和计量状态筛选影响。",
    "otherFailureReasons": "其他错误原因",
    "failureRangeLimit": "失败原因统计支持最多 366 天，请缩短时间范围。",
    "filters": "筛选",
    "timeRange": "时间范围",
    "relativeRanges": "最近时段",
    "back": "返回",
    "timePresets": {
      "past15Minutes": "最近 15 分钟",
      "past30Minutes": "最近 30 分钟",
      "past1Hour": "最近 1 小时",
      "past3Hours": "最近 3 小时",
      "past24Hours": "最近 24 小时",
      "past48Hours": "最近 48 小时",
      "past1Week": "最近 1 周",
      "past1Month": "最近 30 天",
      "past1Year": "最近 365 天",
      "today": "今天",
      "yesterday": "昨天",
      "thisWeek": "本周",
      "previousWeek": "上周",
      "thisMonth": "本月",
      "previousMonth": "上月",
      "thisYear": "今年",
      "previousYear": "去年"
    },
    "customRange": "自定义时间",
    "appliedFilter": "{{name}} {{count}} 项",
    "pendingFilters": "有待应用的筛选",
    "appliedFilters": "已应用筛选",
    "removeFilter": "移除筛选：{{name}}"
  },
  "adminCalls": {
    "result": "调用结果",
    "loadFailed": "调用记录读取失败，请刷新重试",
    "task": "任务",
    "request": "请求",
    "endUser": "终端用户",
    "copyId": "复制{{kind}} ID {{id}}",
    "copyFullId": "复制完整{{kind}} ID",
    "idCopied": "{{kind}} ID 已复制",
    "copyFailed": "复制失败",
    "copyManually": "请手动复制：{{id}}",
    "loadingTask": "正在读取关联任务…",
    "relatedTask": "关联异步任务",
    "taskHint": "下方为任务执行结果，与接口受理状态独立。",
    "emptyResult": "任务已成功，结果为空。",
    "noResult": "任务已结束，没有结果。",
    "pendingResult": "任务尚未完成，暂未产生结果。",
    "openVideo": "打开视频 ↗",
    "openImage": "打开图片 ↗",
    "openAsset": "打开输出资源 ↗",
    "fullTask": "查看完整执行详情 →",
    "async": "异步任务",
    "direct": "直接调用",
    "selectedFilter": "已选筛选值",
    "stored": "已存储",
    "forwarded": "直接转发",
    "pendingStorage": "待回补",
    "storageFailed": "落库失败",
    "noMedia": "无媒体",
    "refreshRequired": "待刷新",
    "storageCount": "{{status}} · {{count}}",
    "unconfirmedFilter": "请从下拉列表选择匹配项，或清空尚未确认的搜索内容",
    "invalidWindow": "开始时间必须早于结束时间",
    "recordId": "请求 / 任务 ID",
    "user": "用户",
    "model": "模型",
    "kind": "类型",
    "status": "状态",
    "disposition": "响应处置",
    "duration": "耗时",
    "received": "接收时间",
    "storageDetails": "存储明细 →",
    "idPlaceholder": "完整请求 ID 或任务 ID",
    "callKind": "调用类型",
    "kindPlaceholder": "全部调用",
    "startLocal": "开始时间（本地时区输入）",
    "endLocal": "结束时间（本地时区输入）",
    "endTime": "结束时间",
    "userPlaceholder": "邮箱、用户名或用户 ID",
    "modelPlaceholder": "模型名称、公开 ID 或内部 ID",
    "protocol": "协议",
    "protocolPlaceholder": "全部协议",
    "statusPlaceholder": "全部状态",
    "apply": "应用筛选",
    "loading": "正在查询调用记录…",
    "empty": "当前筛选没有调用记录",
    "pageCount": "本页 {{count}} 行",
    "cursorPage": " · 游标翻页中",
    "previous": "← 上一页",
    "next": "下一页 →",
    "noMore": "没有更多数据",
    "detailDescription": "请求执行证据：路由尝试、用量记录与结算；正文类字段不在此展示。",
    "calls": "调用记录",
    "detailTitle": "请求 {{id}}",
    "detail": "请求详情",
    "loadingDetail": "正在读取请求详情…",
    "internalId": "内部 UUID",
    "methodPath": "方法与路径",
    "caller": "请求来源",
    "callerReported": "调用方自报",
    "endUserId": "终端用户 ID",
    "endUserIp": "终端用户 IP",
    "clientIp": "调用方 IP",
    "stream": "流式",
    "yes": "是",
    "no": "否",
    "acceptedAt": "接口受理完成时间",
    "taskDuration": "任务总耗时",
    "noTask": "该调用未创建任务，请查看接口受理状态和错误信息。",
    "attempts": "路由尝试（{{count}}）",
    "noAttempts": "该请求没有记录路由尝试（可能在认证或校验阶段被拒绝）。",
    "upstream": "上游",
    "started": "开始",
    "usage": "用量记录（{{count}}）",
    "noUsage": "该请求没有用量证据。",
    "recordedAt": "记录于 {{time}}",
    "rawFields": "{{count}} 个上游原始字段",
    "noRawFields": "无原始字段",
    "metric": "计量项",
    "quantity": "数量",
    "charges": "结算（{{count}}）",
    "noCharges": "该请求没有关联账单。",
    "sales": "销售额",
    "cost": "成本",
    "settledAt": "结算时间",
    "media": "媒体资产",
    "output": "输出",
    "mediaCount": "{{role}} · {{count}} 个",
    "callsView": "调用记录视图",
    "errorsView": "异常视图",
    "allCalls": "全部调用",
    "billingDetails": "计费明细",
    "errors": "异常与错误",
    "callErrors": "调用异常",
    "billingAnomalies": "计费异常"
  },
  "adminUserActivity": {
    "title": "资金与操作记录",
    "kind": "记录类型",
    "loading": "正在加载记录…",
    "empty": "暂无记录",
    "time": "时间",
    "action": "操作",
    "amount": "金额",
    "balanceAfter": "变动后余额",
    "status": "状态",
    "reference": "凭证与审计",
    "recordId": "记录编号：",
    "referenceId": "关联编号：",
    "actor": "操作人：",
    "system": "系统",
    "holdHint": "请求预占会暂时减少可用余额；实际扣费请查看资金流水。",
    "ledger": "资金流水",
    "recharges": "充值记录",
    "holds": "请求预占记录",
    "audit": "操作审计",
    "held": "预占中",
    "captured": "已扣费结算",
    "released": "已解除预占",
    "expired": "已到期解除",
    "credited": "已入账",
    "pending": "待处理",
    "failed": "失败",
    "refunded": "已退款",
    "recharge": "充值",
    "charge": "扣费",
    "refund": "退款",
    "adjustment": "调整",
    "opening": "初始入账",
    "openWallet": "开通钱包",
    "updateUser": "调整用户",
    "updateKey": "调整 Key",
    "setDiscount": "设置用户折扣"
  },
  "adminUsers": {
    "delete": "删除用户",
    "deleteTitle": "确认删除用户",
    "confirmDelete": "确认删除",
    "deleted": "用户已删除",
    "deleteHelp": "仅可删除未使用的账户。有余额、消费、调用、任务或其他业务历史的账户不可删除，请使用封禁；当前账户及最后一位管理员不可删除。",
    "userStatus": "用户状态",
    "walletLabel": "钱包",
    "consumptionTotal": "累计消费（已结算）",
    "cnyBalance": "人民币余额",
    "cnyReserved": "人民币请求预占",
    "cnyWalletStatus": "人民币钱包状态",
    "consumptionHelp": "累计消费统计所有已成功结算费用，已退款费用不计入；各币种分别显示。",
    "requests30d": "近 30 天调用",
    "walletStatusFilter": "钱包状态筛选",
    "allWalletStatuses": "全部钱包状态",
    "requestCount": "{{value}} 次",
    "viewUser": "查看 {{email}}",
    "pageSummary": "本页 {{count}} 行 · 第 {{page}} 页",
    "creditReceipt": "当前余额 {{balance}}；充值编号 {{rechargeId}}；流水编号 {{ledgerId}}",
    "existingCredit": "未重复增加余额；充值编号 {{rechargeId}}",
    "discountValue": "减免 {{percent}}%",
    "roleDescription": "将角色从「{{from}}」调整为「{{to}}」。",
    "banDescription": "封禁后 {{email}} 将无法继续调用，既有账单与历史数据保留。",
    "unbanDescription": "解封后 {{email}} 恢复正常调用。",
    "revokeDescription": "撤销「{{name}}」（{{hint}}）后立即失效，且无法恢复；历史账单不受影响。",
    "retireMultiplierTitle": "停用价格倍率 ×{{value}}",
    "discountPreview": "减免 {{discount}}%，用户按销售价的 {{payable}}% 支付。",
    "multiplierPreview": "客户按标准销售价的 {{percent}}% 支付。",
    "roleAdmin": "管理员",
    "roleDealer": "经销商",
    "roleUser": "用户",
    "banned": "已封禁",
    "active": "正常",
    "unconfigured": "资料待修复",
    "keyActive": "活跃",
    "revoked": "已撤销",
    "expired": "已过期",
    "reason": "原因（必填，写入管理员审计）",
    "reasonExample": "例如：工单 #1234，客户申请解封",
    "unnamed": "未命名",
    "role": "角色",
    "status": "状态",
    "keyCount": "有效 Key 数",
    "walletSummary": "钱包（总余额 / 请求预占）",
    "reserved": "请求预占",
    "walletNotReady": "钱包未就绪",
    "usage30d": "近 30 天调用",
    "lastKeyUse": "最后 Key 使用",
    "details": "详情 ›",
    "title": "用户管理",
    "search": "搜索用户",
    "searchPlaceholder": "邮箱、名称或精确用户 ID",
    "roleFilter": "角色筛选",
    "allRoles": "全部角色",
    "statusFilter": "状态筛选",
    "allStatuses": "全部状态",
    "loading": "正在加载用户列表…",
    "empty": "没有匹配的用户",
    "previous": "← 上一页",
    "next": "下一页 →",
    "noMore": "没有更多用户",
    "saved": "设置已保存",
    "credited": "人工入账成功",
    "alreadyCredited": "本次入账已处理",
    "discountSaved": "专属折扣已保存",
    "multiplierSaved": "价格倍率已保存",
    "multiplierRetired": "价格倍率已停用",
    "loadingDetail": "正在加载用户详情…",
    "name": "名称",
    "maskedKey": "Key（脱敏）",
    "createdAt": "创建时间",
    "expiresAt": "到期时间",
    "revoke": "撤销",
    "back": "← 返回用户列表",
    "viewUsage": "查看该用户用量统计 ↗",
    "adjustRole": "调整角色",
    "repair": "修复用户资料",
    "unban": "解封用户",
    "ban": "封禁用户",
    "registered": "注册时间",
    "emailVerification": "邮箱验证",
    "verified": "已验证",
    "unverified": "未验证",
    "maskedKeys": "API Key（仅显示 prefix 与末四位）",
    "noKeys": "该用户没有 API Key",
    "wallets": "钱包",
    "recharge": "人工入账",
    "currency": "币种",
    "balance": "钱包总余额",
    "available": "可用余额",
    "walletStatus": "钱包状态",
    "frozen": "钱包已冻结",
    "closed": "已关闭",
    "noWallet": "该用户没有钱包",
    "walletUnavailable": "该用户的钱包尚未就绪，暂时无法人工入账。",
    "discounts": "用户折扣",
    "createDiscount": "创建折扣",
    "model": "模型",
    "operation": "操作",
    "discount": "折扣",
    "effective": "生效期",
    "note": "备注",
    "noDiscount": "该用户没有专属折扣",
    "multiplier": "价格倍率",
    "setMultiplier": "设置倍率",
    "subject": "适用主体",
    "allUserKeys": "该用户（全部 Key）",
    "deletedKey": "已删除 Key",
    "scope": "适用范围",
    "allModels": "全局（所有模型）",
    "multiplierShort": "倍率",
    "discounted": "优惠",
    "markup": "加价",
    "standard": "标准价",
    "retire": "停用",
    "noMultiplier": "该用户没有价格倍率规则",
    "multiplierHint": "客户报价 = 标准销售价 × 倍率；Key 级规则优先于用户级，模型级优先于全局，同一时刻只命中一条。同一主体同一范围的规则不可重叠。",
    "usageSummary": "近 30 天用量摘要",
    "usageHint": "按请求接收时间统计，销售额为已成功结算费用；历史调用可能属于已撤销或删除的 Key。",
    "requests": "请求数",
    "sales": "销售额",
    "confirmChange": "确认调整",
    "targetRole": "目标角色",
    "changeRoleTitle": "调整用户角色",
    "confirmRepair": "确认修复",
    "repairHint": "重新建立默认用户资料并设为正常状态；保留注册身份和历史数据。请核实用户注册记录，并填写修复原因。",
    "confirmBan": "确认封禁",
    "confirmUnban": "确认解封",
    "revokeKey": "撤销 Key",
    "revokeKeyTitle": "撤销 API Key",
    "confirmRetire": "确认停用",
    "retireHint": "停用后该规则立即失效，价格回到标准销售价。历史账单按当时快照保留，不受影响。",
    "chooseModel": "搜索并选择模型",
    "searchDiscountModel": "搜索折扣模型",
    "modelSearchPlaceholder": "模型名称或 ID（最多显示 50 个匹配项）",
    "discountModel": "折扣模型",
    "selectModel": "模型",
    "noMatchingModel": "没有匹配模型",
    "capability": "适用能力",
    "discountOperation": "折扣适用能力",
    "loadingOperations": "正在加载能力…",
    "noOperations": "无可用能力",
    "discountRange": "减免比例（%，0–100）",
    "discountPercent": "减免比例",
    "discountExample": "例如 20 表示减免 20%",
    "discountHint": "例如减免 20%，支付销售价的 80%；0 表示恢复基础销售价。有限活动结束后保留原合约的剩余有效期。",
    "effectiveStart": "生效开始（本地时区输入）",
    "discountStart": "折扣生效开始",
    "hasEnd": "设置截止时间（不勾选 = 长期有效）",
    "discountEnd": "折扣生效截止",
    "auditReason": "操作原因（必填，写入审计）",
    "optionalNote": "备注（可选）",
    "discountNoteExample": "例如：大客户合约折扣",
    "creating": "创建中…",
    "userSubject": "该用户（全部 Key 生效）",
    "keyInactive": "，已停用",
    "setMultiplierTitle": "设置价格倍率",
    "effectiveSubject": "生效主体",
    "multiplierSubject": "倍率生效主体",
    "subjectHint": "Key 级倍率优先于用户级命中；同一 Key 同时存在两条时只取 Key 级。",
    "multiplierScope": "倍率适用范围",
    "globalScope": "全局（该主体的所有模型）",
    "modelScope": "指定模型 + 能力",
    "searchMultiplierModel": "搜索倍率模型",
    "multiplierModel": "倍率模型",
    "multiplierOperation": "倍率适用能力",
    "multiplierRange": "价格倍率（0.0001–5，最多 4 位小数）",
    "multiplierExample": "例如 0.9 表示九折",
    "multiplierPricingHint": "客户报价 = 标准销售价 × 倍率：小于 1 为优惠（0.9 = 九折），大于 1 为加价（1.2 = 加价 20%）。同一时刻同一主体只命中一条倍率，不叠加。",
    "multiplierStart": "倍率生效开始",
    "multiplierEnd": "倍率生效截止",
    "multiplierNoteExample": "例如：大客户专属价",
    "saving": "保存中…",
    "saveMultiplier": "保存倍率",
    "rechargeAmount": "入账金额（CNY，正数，最多 8 位小数）",
    "amountExample": "例如 100.00",
    "crediting": "入账中…",
    "confirmCredit": "确认入账"
  },
  "modelAnalytics": {
    "scope": "仅统计已加载的任务样本，不代表完整 API 用量；费用按币种分别展示。",
    "loadedTasks": "已加载任务",
    "charges": "已记录费用",
    "title": "当前账号的模型任务",
    "sample": "已加载样本",
    "empty": "暂无分析数据"
  },
  "conversation": {
    "completed": "完成 {{completed}}/{{total}}",
    "totalTokens": "总计 {{value}} tokens",
    "title": "多模型并发对话",
    "modelCount": "{{count}} 个模型",
    "layout": "对话分栏",
    "oneColumn": "单栏排版",
    "twoColumns": "双栏排版",
    "threeColumns": "三栏排版",
    "totalDurationHint": "各模型请求用时之和，不是本轮实际等待时间",
    "totalDuration": "累计模型用时 {{duration}}",
    "structuredInput": "结构化输入",
    "copyId": "复制 ID：{{id}}",
    "broadcastPlaceholder": "向全部 {{count}} 个模型广播追问…",
    "sending": "追问中…",
    "broadcast": "全模型追问",
    "modelResult": "{{model}} 对话结果",
    "markBest": "标记为最佳答案",
    "unmarkBest": "取消最佳答案标记",
    "requesting": "正在请求此模型…",
    "generatingReply": "正在生成追问回复…",
    "replyFailed": "追问回复失败",
    "reply": "追问回复",
    "emptyResponse": "模型返回了空文本响应。",
    "singlePlaceholder": "向 {{model}} 单独追问…",
    "sendSingle": "向 {{model}} 发送单独追问",
    "noEndpoint": "{{model}}：没有可用文字端点",
    "streamEvents": "{{protocol}} SSE · 事件数：{{count}}",
    "streamStatus": "{{protocol}} SSE · {{status}}",
    "reasoningEvidence": "推理信息：",
    "observed": "已返回",
    "notObserved": "未返回",
    "notReported": "未报告",
    "reasoningItems": "条目："
  },
  "tokenUsage": {
    "title": "Token 与上下文分布",
    "system": "系统提示词",
    "user": "输入 Token (对话与提问)",
    "reasoning": "思维链 / 思考",
    "tools": "工具调用",
    "output": "输出 Token (模型生成回复)",
    "firstTurn": "第 1 轮对话 (初始请求)",
    "followupTurn": "第 {{count}} 轮对话 (追问 {{followup}})",
    "systemDetail": "{{count}} 字符系统预设",
    "noSystem": "无独立系统提示词",
    "noInput": "无文本输入",
    "reasoningDetail": "已返回思维链 · {{count}} tokens{{items}}",
    "reasoningItems": " ({{count}} 条目)",
    "noReasoning": "未记录推理信息",
    "toolDetail": "调用 {{count}} 次: {{names}}",
    "noTools": "无工具调用",
    "outputDetail": "{{count}} 字符生成回复",
    "generating": "正在生成…",
    "noOutput": "无回复文本",
    "distribution": "Token 分类分布",
    "totalDuration": "总用时 {{duration}}",
    "total": "Token 总量",
    "inputOutput": "输入: {{input}} · 输出: {{output}}",
    "turns": "轮次明细 (共 {{count}} 轮对话)",
    "turnHint": "每轮的行为与结果",
    "conversation": "对话",
    "thinkingItems": "深度思考 · {{count}} 条",
    "thinking": "深度思考",
    "estimateHint": "部分分类依据文本长度估算，仅供分析；不作为计费依据。",
    "open": "查看 {{model}} Token 分布与用时明细",
    "outputCount": "(输出: {{value}})",
    "toolCount": "已执行 {{count}} 次工具调用",
    "unrecorded": "Token 未记录",
    "unrecordedHint": "部分或全部轮次未保存 Token 用量，未记录的数值不显示为 0。"
  },
  "requestHistory": {
    "expandRequests": "展开其余 {{count}} 条请求",
    "collapseRequests": "收起其余 {{count}} 条请求",
    "earlierRequests": "较早的连续文本请求",
    "groupEnd": "本组请求结束",
    "clientIp": "调用方 IP：{{value}}",
    "endUserIp": "终端用户 IP：{{value}}",
    "pagination": "调用记录分页",
    "pageNumber": "第 {{page}} 页",
    "loadingPage": "正在加载",
    "loadFailed": "后续记录加载失败，请重试",
    "details": "详情",
    "openRecord": "查看请求 {{id}}",
    "list": "列表视图",
    "compact": "紧凑视图",
    "grid": "网格视图",
    "expand": "展开",
    "collapse": "收起",
    "preparation": "发出请求",
    "generation": "模型处理",
    "mediaInfo": "媒体信息",
    "mediaSize": "大小：{{size}}",
    "mediaDuration": "时长：{{duration}}",
    "refunded": "已退款",
    "noSettlement": "暂无结算记录",
    "costPrefix": "费用：",
    "caller": "请求来源：{{value}}",
    "endUser": "终端用户 ID：{{value}}",
    "copyEndUserId": "复制终端用户 ID",
    "previousMedia": "上一张",
    "nextMedia": "下一张",
    "selectMedia": "查看第 {{count}} 项结果",
    "videoFailed": "视频生成失败",
    "imageFailed": "图片生成失败",
    "noMedia": "请求未返回可用媒体结果",
    "errorCode": "错误码：{{code}}",
    "conversation": "对话",
    "duration": "用时",
    "noInput": "无请求参数",
    "noResponse": "未保留响应",
    "responseStatus": "返回情况",
    "platformError": "平台统一错误",
    "platformResponseParams": "平台返回参数",
    "providerResponseParams": "原厂返回参数",
    "providerResponseMissing": "未保留原厂返回参数",
    "errorParam": "参数：{{param}}",
    "upstreamError": "原厂错误",
    "upstreamDecodedError": "原厂错误（已解码）",
    "upstreamMessageMissing": "原厂未提供可直接展示的错误说明。",
    "upstreamErrorMissing": "暂无原厂错误内容",
    "upstreamRedacted": "敏感内容已删减",
    "upstreamTruncated": "错误证据已截断",
    "upstreamUnavailable": {
      "no_response": "未收到上游响应",
      "not_retained": "原厂错误未保留",
      "unsupported_capture": "无法采集原厂错误",
      "error_not_emitted": "上游未发出错误内容",
      "size_limit": "原厂错误超过大小限制"
    },
    "errorCategory": "分类：{{category}}",
    "retryableYes": "可重试：是",
    "retryableNo": "可重试：否",
    "loading": "正在读取请求详情…",
    "notFound": "未找到该请求",
    "title": "调用记录",
    "description": "已加载的模型体验与 API 请求记录；可继续加载后续历史。",
    "modelCategory": "模型分类",
    "allModelCategories": "全部模型分类",
    "allTypes": "全部类型",
    "taskType": "异步任务",
    "apiType": "接口调用",
    "noRecords": "0 条记录",
    "pageRange": "第 {{start}}–{{end}} 条，已加载 {{count}} 条{{more}}",
    "emptyHint": "请尝试调整搜索关键词或重置筛选条件。",
    "noPrompt": "无提示词",
    "restoreConversation": "恢复对话，继续提问",
    "task": "任务",
    "sessionTurns": "会话 · {{count}} 轮",
    "unknownModel": "未知模型",
    "output": "生成结果",
    "copySessionId": "复制 Session ID",
    "copyRequestId": "复制 Request ID",
    "seed": "随机种子",
    "size": "尺寸",
    "aspectRatio": "画面比例",
    "steps": "步数",
    "guidance": "引导强度",
    "notCharged": "未扣费"
  },
  "wallet": {
    "openingBalance": "初始余额",
    "recharge": "充值",
    "charge": "扣费",
    "refund": "退款",
    "adjustment": "调整",
    "entryType": "类型",
    "amount": "金额",
    "balanceAfter": "变动后余额",
    "reference": "关联单号",
    "description": "预付费余额与充值流水；调用计费模型会先预冻结、结算时扣费。",
    "entries": "流水记录",
    "noEntries": "暂无流水记录",
    "available": "可用余额",
    "reserved": "请求预占",
    "understood": "知道了",
    "rechargeTitle": "充值 {{currency}} 钱包",
    "rechargeGuide": "自助充值暂未开放。企业合同客户请联系商务办理充值；管理员入账后，流水会更新在本页。",
    "model": "模型",
    "operation": "操作",
    "viewRequest": "查看请求与计费",
    "noWallet": "暂无钱包"
  },
  "taskCost": {
    "awaitingReview": "费用待核对",
    "noRecordedCost": "暂无已记录费用",
    "unconfirmed": "（{{count}} 个任务费用未确认）",
    "pending": "待结算",
    "failed": "结算异常",
    "refunded": "含退款，请核对账单",
    "mixedCurrencies": "多币种，无法合计",
    "usageUnavailable": "缺少计费用量",
    "usageInvalid": "计费用量无效",
    "usageIncomplete": "计费用量不完整",
    "evidenceInvalid": "计费证据无效",
    "evidenceIncomplete": "计费证据不完整",
    "holdUnavailable": "余额预授权异常",
    "priceUnavailable": "缺少销售价格",
    "pricingUnavailable": "销售价格配置异常"
  },
  "settings": {
    "description": "账号、用量与开发者配置。",
    "general": "通用",
    "usageBilling": "用量与计费",
    "wallet": "钱包",
    "developer": "开发者",
    "keyCreateFailed": "密钥创建失败",
    "keyRevokeFailed": "密钥撤销失败",
    "key": "密钥",
    "scopes": "权限范围",
    "lastUsed": "最后使用",
    "revoke": "撤销",
    "keysDescription": "完整密钥只在创建时显示一次；之后仅保留不可逆摘要。",
    "newKey": "新建密钥",
    "noKeys": "当前账号还没有 API Key",
    "moreKeys": "加载更多密钥",
    "revokeTitle": "撤销 API 密钥？",
    "revokeDescription": "{{name}} 将立即失效，此操作无法撤销。",
    "revokeKey": "撤销密钥",
    "keyCreated": "API 密钥已创建",
    "createKey": "创建 API 密钥",
    "copyKeyWarning": "请立即复制此密钥，关闭后将无法再次查看。",
    "copyKey": "复制密钥",
    "defaultKeyName": "默认密钥",
    "expiration": "有效期",
    "neverExpires": "永不过期",
    "days": "{{count}} 天",
    "oneYear": "1 年",
    "creatingKey": "创建中…",
    "accountDescription": "当前控制台登录身份。",
    "searchNavigation": "搜索{{title}}",
    "signInDetail": "登录后才能查看当前账号的任务、请求与用量。"
  },
  "usageSample": {
    "title": "近期用量样本",
    "description": "分别统计最近 20 条任务和 API 请求，并非完整账单；金额按币种分开，未知费用不计为免费。",
    "recentSample": "最近 {{count}} 条样本",
    "modelEndpoint": "模型端点",
    "taskCount": "任务数",
    "successCount": "成功数",
    "recordedCost": "已记录费用",
    "sampleRequests": "样本请求数",
    "succeededTasks": "成功任务",
    "failedSamples": "失败或拒绝样本",
    "modelsUsed": "使用模型数",
    "successRate": "成功率",
    "requestsHint": "最近 API 请求样本",
    "costHint": "仅已加载任务，不代表完整账单",
    "submittedTasks": "共提交 {{count}} 个任务",
    "failuresHint": "任务与请求样本分别计数",
    "modelsHint": "不同的任务模型",
    "rateHint": "按任务终态统计",
    "trend": "用量趋势",
    "dailyRequests": "{{date}}：{{count}} 个请求",
    "distribution": "用量分布",
    "tasksByModel": "按模型统计任务",
    "noTasks": "暂无任务用量。",
    "modelUsage": "模型 API 用量",
    "currentAccount": "当前账号",
    "noUsage": "暂无用量数据"
  },
  "taskDocs": {
    "authorization": "Bearer 后填写 Nexra API Key。",
    "idempotencyTitle": "幂等键",
    "idempotency": "每次新任务使用不同的值；重试同一次提交时保持不变。",
    "requestFormat": "请求格式",
    "publicModelId": "平台模型 ID",
    "modelInput": "模型参数",
    "callbackTitle": "任务完成回调地址",
    "callback": "可选的公网 HTTPS 地址。任务成功、失败或取消后，Nexra 向此地址 POST 完成通知；URL 查询参数原样保留。不填写时可查询任务结果。",
    "metadataTitle": "业务附加信息",
    "metadata": "可选的 JSON 对象，例如订单号、项目 ID。在请求详情中查看，不发送给模型上游。不要放密钥或敏感信息。",
    "taskResult": "任务状态与结果。output 在有结果时才出现。",
    "taskId": "平台任务 ID",
    "requestId": "请求 ID",
    "requestDetails": "使用 GET /v1/requests/{requestId} 查看费用、业务附加信息和分阶段耗时。",
    "taskStatus": "任务状态",
    "modelOutput": "模型最终结果",
    "assetsTitle": "媒体资源",
    "assets": "平台记录的媒体资源。仅就绪资源提供可访问地址；不替换 output 中的原始链接。",
    "assetId": "资源 ID",
    "assetKind": "资源类型",
    "assetStatus": "保存状态",
    "assetUrl": "访问地址",
    "downloadUrl": "下载地址",
    "error": "错误信息",
    "errorCode": "错误码",
    "errorMessage": "错误说明",
    "nativeCallbackTitle": "回调地址",
    "nativeCallback": "接收任务状态通知；Nexra 记录结果后按原生格式转发。",
    "nativeCallbackChallenge": "MiniMax 直接向此地址发送状态通知；首次验证须在 3 秒内原样返回 challenge。",
    "upstreamTaskId": "上游任务 ID",
    "returnedId": "创建任务返回的 id。",
    "returnedOrUpstreamId": "创建任务返回的 id，或上游回调中的任务 ID。",
    "modelName": "模型名称",
    "accepted": "任务已受理。使用 id 查询状态和结果；幂等重试返回同一任务的当前状态。",
    "queried": "返回任务状态和结果。HTTP 200 表示查询成功，任务是否完成请查看 status。",
    "cancelled": "仅尚未执行的排队任务可取消。已开始执行时返回 HTTP 409，任务继续运行；已结束的任务保持原状态，不删除记录。",
    "deleted": "取消或删除受上游任务状态限制；不支持时原样返回上游错误。删除记录不等于停止生成。",
    "selectModel": "选择要调用的平台模型：{{modelId}}。也可填写该模型已登记的公开别名。"
  },
  "apiDocs": {
    "errorRequestHeadersTitle": "请求头",
    "errorResponseHeadersTitle": "响应头",
    "errorRequestHeadersExample": "Task 创建请求头示例",
    "errorResponseHeadersExample": "读取可选响应头示例",
    "errorPageTitle": "错误码与异常处理",
    "errorHeadersTitle": "请求与响应头",
    "errorHeaderName": "Header 名称",
    "errorHeaderRule": "处理规则与适用场景",
    "errorHeaderRules": {
      "authorization": "API Key 调用通常使用 Authorization: Bearer <NEXRA_API_KEY>。平台会话也可用于支持会话的接口；Native 认证形式按所选协议，不能一概要求 Bearer。",
      "content_type": "JSON 请求使用 application/json；文件编辑等 multipart 请求按原协议格式发送，由客户端生成 boundary。并非所有 Native 请求都是 JSON。",
      "accept_language": "公共 message 支持 zh-CN 与 en；未提供或不支持的值（如 cn）回退 en，不翻译原厂正文。",
      "x_nexra_client_request_id": "可选。调用者可生成 UUID 标记原请求，平台缺省会生成 ID；用于定位请求，不是幂等键。查询平台记录时使用已发送的这个 ID。",
      "idempotency_key": "用于要求幂等的 Task 创建等接口；重复发送相同请求内容时复用同一个幂等键。并非所有 Native 入口都要求此头，不用于决定失败后重新生成。",
      "x_request_id": "响应中可能保留既有上游值；Native 原生值可能是原厂 ID，不能一概当作 nexraRequestId。平台权威 ID 见统一 nexraRequestId，或原请求客户端 UUID。",
      "content_language": "平台已本地化的统一错误与 Task / Request 读取路径标明 message 的语言；不保证每个 Native 原厂响应都带此头。",
      "x_nexra_error_code": "Native 已分类错误存在此头时读取统一码，不代表所有失败都有；流响应头发出后出现的错误可能无法更新该头。"
    },
    "errorShortMeaning": "简短含义",
    "errorActionMessage": "原因与操作说明",
    "errorNexraInterpretation": "在 Nexra 如何理解",
    "errorJudgement": "如何判断与处理",
    "errorHttpTitle": "HTTP 状态码",
    "errorTaskTitle": "Task 状态",
    "errorAllCodesTitle": "全部错误码",
    "errorPageToc": "本页目录",
    "errorCodeMeanings": {
      "content_policy_violation": "内容政策审核拦截",
      "rate_limited": "请求频率或并发超限",
      "invalid_request": "请求参数不符合要求",
      "asset_too_large": "输入资源超过文件大小限制",
      "upstream_timeout": "等待原厂响应超时",
      "upstream_busy": "原厂服务繁忙",
      "upstream_unavailable": "原厂服务暂不可用",
      "execution_outcome_unknown": "执行结果暂无法确认",
      "stream_interrupted": "响应流中断",
      "task_execution_timeout": "任务超过总时限"
    },
    "errorHttpMeanings": {
      "200": {
        "meaning": "请求成功",
        "guidance": "GET 查询成功不等于任务执行成功；仍需读取 Task status、nexraError 和流终态。"
      },
      "202": {
        "meaning": "请求已受理",
        "guidance": "受理不等于生成成功；保存 Task ID 后查询状态与结果。"
      },
      "400": {
        "meaning": "请求无效或无法处理",
        "guidance": "根据当前 nexraError.code 和参数说明修正请求；Native 原厂 400 也可能是审核拒绝，不能只按状态猜分类。"
      },
      "401": {
        "meaning": "缺少有效身份认证",
        "guidance": "平台请求检查 Nexra 凭证；Native 透传的原厂 401 属于其认证边界，不要自动认定客户 Nexra Key 无效。"
      },
      "402": {
        "meaning": "标准中保留的状态码",
        "guidance": "Nexra 可用于余额或预算限制。以公共 nexraError.code / nexraError.message 为准，核对平台余额与适用预算。"
      },
      "403": {
        "meaning": "服务拒绝执行请求",
        "guidance": "检查权限、资源归属和公共错误说明；原厂拒绝与平台权限分开判断。"
      },
      "404": {
        "meaning": "目标资源未找到",
        "guidance": "核对路由、资源或模型 ID 与当前身份的可见范围。"
      },
      "408": {
        "meaning": "服务器等待完整请求超时",
        "guidance": "检查请求发送与网络；不直接等同模型推理超时，重新生成前核对原请求是否已受理。"
      },
      "409": {
        "meaning": "请求与当前资源状态冲突",
        "guidance": "检查状态、幂等键及其对应请求内容，避免重复生成。"
      },
      "413": {
        "meaning": "请求内容超过允许大小",
        "guidance": "检查输入文件或请求体限制，缩小请求；这不等同公共诊断的 16 KiB 预算。"
      },
      "422": {
        "meaning": "请求内容可解析但无法按其指令处理",
        "guidance": "按参数或语义校验说明修改输入，不直接解释成 JSON 解析失败。"
      },
      "429": {
        "meaning": "请求过于频繁",
        "guidance": "降低频率或并发，检查适用配额；不保证一定有 Retry-After 响应头。"
      },
      "500": {
        "meaning": "服务遇到内部错误",
        "guidance": "使用平台 ID 定位记录；原请求结果可能需要核对，不保证重试一定安全。"
      },
      "502": {
        "meaning": "网关收到无效上游响应",
        "guidance": "区分平台与原厂状态，查看原请求和诊断后决定处理，不自动重复生成。"
      },
      "503": {
        "meaning": "服务暂不可用",
        "guidance": "检查可用状态和原请求进度；不保证上游未执行，不直接自动重试生成。"
      },
      "504": {
        "meaning": "网关等待上游及时响应超时",
        "guidance": "上游可能继续执行；先查询原 Task 或请求结果，再决定是否重新提交。"
      }
    },
    "errorTaskMeanings": {
      "queued": {
        "meaning": "任务已入队",
        "guidance": "等待调度，使用同一个 Task ID 查询，不重复创建。"
      },
      "running": {
        "meaning": "任务执行中",
        "guidance": "继续查询进度；未有终态时不要宣称失败或生成完成。"
      },
      "succeeded": {
        "meaning": "模型执行成功",
        "guidance": "仍需查看 deliveryStatus 与 assets：preparing 表示后台保存中，ready 表示结果就绪，failed 表示交付失败；不要因此重新生成。"
      },
      "failed": {
        "meaning": "任务执行失败",
        "guidance": "查看 nexraError.code、平台说明与原厂诊断；执行结果未知时先核对原请求，避免重复提交。"
      },
      "cancelling": {
        "meaning": "正在请求取消",
        "guidance": "取消尚未确认；继续查询，不能当作已取消或断言原厂未执行。"
      },
      "cancelled": {
        "meaning": "任务已取消",
        "guidance": "这是平台终态，不保证原厂从未执行；新提交前核对原请求与已产生的结果。"
      }
    },
    "errorReference": "错误参考",
    "errorShape": "错误 JSON 与示例",
    "errorHttpExample": "同步 HTTP 错误",
    "errorTaskExample": "异步 Task 失败",
    "errorNativeExample": "Native 原厂响应",
    "errorFieldsTitle": "字段说明",
    "errorField": "字段",
    "errorDescription": "含义与处理建议",
    "errorCode": "错误码",
    "errorCommon": "常见错误码",
    "errorAllCodes": "全部错误码（{{count}}）",
    "errorFields": {
      "nexraHttpStatus": "与 nexraRequestId 同一次原平台请求的实际 HTTP 状态；Task 保留原创建状态，不用后续 GET 的 200 覆盖。",
      "upstreamHttpStatus": "捕获到的原厂 HTTP 状态，与平台状态独立。",
      "nexraRequestId": "平台请求 ID，根部只出现一次；成功和失败均可用于定位请求。",
      "upstreamRequestId": "来自原厂响应头的请求 ID，不与平台 ID 混用。",
      "nexraError": "平台统一错误；成功时省略。",
      "nexraError_code": "平台错误码，用于程序精确判断。",
      "nexraError_message": "平台原因与操作说明，随请求语言本地化。",
      "nexraError_param": "可选的已验证参数名或路径。",
      "upstreamError": "采集到的原厂错误内容，保持原厂字段与文案，不额外包 body；可能是标量或 null，也可能脱敏或缺失。 安全采集包括元数据的上限为 16 KiB。",
      "upstreamErrorMessage": "从已采集诊断中提取的原厂错误文本，保留原语言和换行；没有可识别文本时省略。",
      "upstreamRedacted": "为 true 时表示诊断内容经过脱敏。",
      "upstreamTruncated": "为 true 时表示诊断采集受大小限制，内容可能省略。",
      "upstreamUnavailableReason": "未捕获正文的原因，不等同未调用原厂。",
      "upstreamFormat": "sse 或 decoded 表示错误帧或已解码诊断，不承诺原始字节。",
      "upstreamEvent": "捕获到的上游 SSE 事件名。"
    },
    "taskIntro": "提交异步任务后，可查询状态和结果，或通过 callback_url 接收完成通知。",
    "protocolIntro": "通过 {{protocol}} 调用此模型。",
    "unavailable": "此模型暂无可用接口。",
    "client": "Nexra TypeScript 客户端支持 Bun、Node.js 和现代 JavaScript 运行时，也可以直接调用 HTTP API。",
    "submit": "发送目录模型 ID 和输入对象。重复使用同一个幂等键会返回原任务，不会重复发起生成。",
    "query": "使用提交返回的任务 ID 查询状态与结果。",
    "files": "传入公开 HTTPS 媒体链接，或使用上传后获得的资源地址。",
    "snapshots": "这些快照小版本锁定特定时间点权重，与当前模型共享完全相同的接口端点与参数定义。调用时在请求体中传入对应快照 ID 即可。",
    "snapshotCount": "共 {{count}} 个快照版本",
    "providerParameters": "此入口的参数格式可能与官方接口不同，请以所选渠道文档为准。"
  },
  "parameters": {
    "operations": "接口操作",
    "operationDocs": "{{operation}}接口文档",
    "copied": "已复制{{label}}",
    "copyFailed": "复制失败",
    "copyManually": "请手动选中复制",
    "displayMode": "参数展示方式",
    "visual": "可视化",
    "json": "JSON 源码",
    "definition": "参数定义",
    "copyDefinition": "复制参数定义",
    "selectExample": "选择请求示例",
    "example": "示例 {{number}}",
    "requestExample": "请求示例 {{number}}",
    "copyExampleNumber": "复制请求示例 {{number}}",
    "copyExample": "复制请求示例",
    "operation": {
      "create": "创建任务",
      "query": "查询任务",
      "cancel": "取消任务",
      "delete": "取消或删除",
      "generate": "生成图片",
      "audioGenerate": "生成音频",
      "edit": "编辑图片",
      "videoEdit": "编辑视频",
      "videoExtend": "延展视频",
      "stream": "流式请求",
      "request": "请求"
    },
    "requestOperation": {
      "list": "资源列表",
      "presets": "官方资源库",
      "text-to-video": "文生视频",
      "image-to-video": "图生视频",
      "omni-video": "全能参考生视频",
      "text2video": "文生视频",
      "image2video": "图生视频",
      "transition": "首尾帧生成",
      "reference2video": "参考图生视频",
      "fusion": "参考图生视频",
      "convert": "合成语音",
      "stream": "流式响应",
      "convert-with-timestamps": "合成语音及时间戳",
      "stream-with-timestamps": "流式响应及时间戳",
      "remix": "续接视频",
      "delete-video": "删除视频",
      "delete-interaction": "删除交互记录"
    },
    "response": {
      "create": "创建响应",
      "query": "查询响应",
      "cancel": "取消响应",
      "delete": "删除响应",
      "result": "返回结果"
    },
    "nativeOutput": "模型原生结果",
    "nativeInput": "模型原生参数",
    "alwaysReturned": "必定返回",
    "required": "必填",
    "generatedResult": "生成结果",
    "outputScope": "以下为 output 对象内的字段。",
    "inputScope": "以下字段填写在请求体的 input 对象中。",
    "fixedValue": "固定值",
    "values": "取值",
    "defaultSuffix": "· 默认",
    "urlItem": "每一项为 URL 链接",
    "contentTypes": "content 数组的内容类型",
    "missingStructure": "尚未补充具体结构，请以对应接口文档为准。",
    "singleMessage": "输入消息（仅一条） <code>input.messages[0]</code> · <code>role: \"user\"</code>",
    "rejectedField": "不接受字段 <code>{{name}}</code>。",
    "typedContent": "按顺序组合内容，每项通过 <code>type</code> 指定类型。",
    "content": "按顺序组合内容，每一项选择以下一种字段。",
    "separator": "；",
    "roles": "素材用途：{{roles}}",
    "listSeparator": "、",
    "contentType": "{{type}} 内容类型",
    "formats": "接受的格式 · {{count}} 种",
    "itemFormats": "每一项接受的格式 · {{count}} 种",
    "format": "格式 {{number}}",
    "reference": "引用定义：<code>{{reference}}</code>（详见 JSON 源码）",
    "fields": "包含的字段 · {{count}} 项",
    "itemFields": "每一项包含的字段 · {{count}} 项",
    "anyGroup": "至少提供一组：{{groups}}。",
    "oneGroup": "只能满足一组：{{groups}}。",
    "combinationConstraints": "完整组合约束见 JSON 源码。",
    "orSeparator": "，或 ",
    "autoRange": "{{min}}～{{max}}{{unit}}；{{auto}} 为自动",
    "fixed": "固定为 {{value}}{{unit}}",
    "range": "范围 {{min}}～{{max}}{{unit}}",
    "minimum": "不小于 {{value}}{{unit}}",
    "maximum": "不大于 {{value}}{{unit}}",
    "exclusiveMinimum": "大于 {{value}}{{unit}}",
    "exclusiveMaximum": "小于 {{value}}{{unit}}",
    "exactItems": "数量 {{count}} 项",
    "minItems": "提供时至少 {{count}} 项",
    "maxItems": "最多 {{count}} 项",
    "minLength": "至少 {{count}} 个字符",
    "maxLength": "最多 {{count}} 个字符",
    "multipleOf": "按 {{value}}{{unit}} 的倍数取值",
    "pattern": "完整格式约束见 JSON 源码",
    "unique": "各项不能重复",
    "stringOrList": "填写单个字符串，或按顺序填写字符串数组。",
    "binary": "二进制数据",
    "stringOrListType": "字符串 / 字符串列表",
    "types": {
      "string": "字符串",
      "integer": "整数",
      "number": "数值",
      "boolean": "布尔值",
      "object": "对象",
      "array": "列表",
      "null": "空值"
    },
    "link": "链接",
    "typedList": "{{type}}列表",
    "multipleFormats": "多种格式",
    "mediaSource": "填写公开 URL，或选择已上传的平台资源 ID。",
    "mediaSourceType": "URL / 资源 ID",
    "role": {
      "first_frame": "首帧",
      "last_frame": "尾帧",
      "reference_image": "参考图",
      "reference_video": "参考视频",
      "reference_audio": "参考音频"
    },
    "secondsUnit": "秒",
    "descriptions": {
      "geminiContentsHistory": "完整的 Gemini contents 历史；提供后替代消息和媒体的自动组装。",
      "geminiFunctionConfig": "tool_config.function_calling_config 的简写形式。",
      "geminiToolConfig": "Gemini ToolConfig，包含 functionCallingConfig 或 function_calling_config、mode 和 allowedFunctionNames。",
      "geminiTools": "Gemini 工具定义，使用 REST 的 functionDeclarations 或 SDK 的 function_declarations。",
      "geminiThoughtParts": "thought 部分返回的思考内容。",
      "geminiFunctionCalls": "Gemini 函数调用，包含 name、args 和可选的 id。",
      "geminiContents": "按顺序提供包含 role 和 parts 的 Gemini contents。",
      "geminiContent": "包含 role 和 parts 的 Gemini 原生 Content 对象。",
      "generationSettings": "此模型支持的生成设置。",
      "geminiSharedOutputTokens": "输入和输出共享上下文中的最大正文与思考 Token 数。",
      "thinkingLevel": "模型在返回响应前进行推理的强度。",
      "geminiIncludeThoughts": "是否在响应中返回 thought 部分；此设置不启用或关闭推理。",
      "geminiSseFraming": "使用 SSE 格式返回 Gemini 流式响应。",
      "mediaLimits": "请求体不超过 64 MB。媒体文件的时长、尺寸与大小由上游校验。",
      "aspectRatio": "生成内容的画面比例。",
      "resolution": "生成内容的分辨率。",
      "duration": "生成视频或音频的时长，单位为秒。",
      "videoPrompt": "描述视频的主体、动作、镜头运动和风格。",
      "imagePrompt": "描述要生成的图片，或希望对输入图片做出的修改。",
      "imageInputs": "输入图片。支持多种用途时，请指定图片的用途。",
      "videoInputs": "输入视频。支持多种用途时，请指定视频的用途。",
      "httpVideoSizeLimit": "通过 HTTP 链接提供的视频不能超过 15 MB（15,000,000 字节）。请压缩较大的视频，或提供受支持的 Google Cloud Storage URI。",
      "audioInputs": "输入音频。支持多种用途时，请指定音频的用途。",
      "userMessage": "发送给语言模型的消息或指令。",
      "includeAudio": "是否为生成内容包含音频。",
      "stream": "是否在生成过程中逐步返回响应。",
      "seed": "随机种子，用于提高生成结果的可复现性。",
      "speech": "需要合成为语音的文本。",
      "voice": "用于语音生成的音色 ID。",
      "outputCount": "需要生成的结果数量。",
      "negativePrompt": "描述不希望出现的内容、风格或瑕疵。",
      "outputFormat": "生成媒体的输出格式。",
      "systemPrompt": "独立于用户消息提供的系统指令。",
      "anthropicSystem": "独立于用户消息提供的系统指令或上下文。",
      "publicModelId": "Nexra 对外公开的 Model ID。",
      "anthropicMessages": "Anthropic Messages 协议的消息列表。",
      "clientTools": "由客户端执行的工具定义。",
      "toolChoice": "工具选择策略。",
      "claudeThinking": "Claude 推理配置。",
      "outputEffort": "输出格式与处理强度配置。",
      "anthropicStream": "是否返回 Anthropic SSE 事件流。",
      "maxOutputTokens": "本次生成允许的最大输出 Token 数。",
      "nativeResponse": "协议原生响应；流式请求返回该协议定义的事件流。",
      "claudeMaxOutputTokens": "最大输出 Token 数；此模型最高支持 128,000。",
      "claudeWebSearch": "允许模型调用 Anthropic 服务端网页搜索工具。",
      "claudePromptCache": "将可复用的提示词内容标记为 Anthropic 提示词缓存。",
      "claudeThinkingContent": "所选推理模式提供推理内容时返回的内容。",
      "claudeThinkingControl": "默认启用推理；low、medium、high 可关闭，xhigh 和 max 必须启用。",
      "claudeImages": "最多输入 600 张 JPEG、PNG、GIF 或 WebP 图片，支持 URL 或 Base64；原生 Claude API 限制单张 Base64 图片不超过 10 MB，标准请求体不超过 32 MB。",
      "agentSkillArtifacts": "Agent Skills 生成并回传到 OSS 的文档，包含 URL、文件名、MIME 类型和字节数。",
      "functionCallingOutput": "模型请求调用的工具列表（包含 ID、名称和输入）；调用方执行后回传 tool_result。",
      "responseBody": "正文；流式 NDJSON 行中的 response 片段使用相同结构。",
      "effortGuidance": "用于调节响应深度和 Token 使用量的软性指引；上游默认值为 high。",
      "claudeThinkingMaxTokens": "本次生成的最大输出 Token 数，包括思考和正文，上限为 128,000。",
      "claudeThinkingSummary": "显式选择显示思考内容时返回的推理摘要。",
      "sonnet55Effort": "控制自适应思考的深度和 Token 使用量，默认 high。",
      "sonnet55Thinking": "默认自适应思考；between_tools 关闭回答前的思考，仅支持 low、medium 或 high effort。",
      "sonnet55ToolChoice": "工具选择策略；Sonnet 5.5 只支持 auto 或 none。",
      "gpt61SolEffort": "GPT-6.1 Sol 的推理强度；支持 low、medium、high、xhigh 和 max，默认 medium。",
      "responsesCacheKey": "提示词缓存键；相同前缀可使用同一键，提高缓存命中率。",
      "responsesFormat": "文本、json_object 或映射到 text.format 的 JSON Schema 格式定义。",
      "responsesInput": "Responses 文本、消息或输入项。",
      "responsesInstructions": "系统或开发者指令。",
      "responsesSafety": "保护用户隐私的稳定标识，最多 64 个字符。",
      "responsesStore": "允许上游保存响应，以便通过 previous_response_id 接续；默认关闭。",
      "responsesStream": "是否返回 Responses 类型化 SSE 事件流。",
      "responsesVerbosity": "控制回答详略；low 更简短，medium 均衡，high 更详细。",
      "videoUrls": "生成的视频 URL 列表。",
      "qwenImageEditModelId": "官方模型 ID 为 qwen-image-edit-plus；也可填写该模型已登记的渠道导入 ID。",
      "qwenImageEditContent": "包含一条编辑文本和 1～3 张图片；图片顺序以数组中的顺序为准。",
      "qwenImageEditPrompt": "编辑要求，上限 800 tokens，由上游分词处理。",
      "qwenImageEditImages": "支持公开 URL、Data URL 或同一上游账号和模型的临时 oss:// 地址。最多 3 张，每张不超过 10 MB；建议宽高 384～3072 像素。",
      "qwenImageEditSize": "填写 WIDTH*HEIGHT，宽高各为 512～2048 像素。上游会将实际尺寸调整到附近的 16 倍数；省略时参照最后一张输入图的比例。",
      "qwenImageEditCount": "输出 1～6 张，省略时为 1。",
      "qwenImageEditNegativePrompt": "描述不希望出现的内容，最多 500 个字符。",
      "qwenImageEditPromptExtend": "让上游优化编辑提示词。",
      "qwenImageEditWatermark": "在图片右下角添加上游水印。",
      "qwenImageEditSeed": "省略时随机生成；相同种子不能保证输出完全一致。",
      "qwenImageEditTemporaryImage": "上游临时图片地址，通常有效 24 小时。",
      "upstreamErrorOnly": "上游发生错误时返回。",
      "h3LocalReferenceContent": "提供提示词和至少一个图片、视频或音频参考素材。",
      "baiduKlingContent": "提供提示词，可选添加首帧和尾帧。",
      "baiduHailuoContent": "提供提示词或一张首帧图片。",
      "baiduHailuoFastContent": "提供一张首帧图片，可选填写提示词。",
      "baiduC1Content": "提供一条提示词，可选添加最多七张具名主体或背景参考图。",
      "baiduViduContent": "使用提示词、首尾帧或最多七张参考图片生成视频。",
      "googleOmniContent": "提供一条提示词，可搭配一张图片生成动画。",
      "googleOmniPrevious": "复用上一轮生成结果进行连续编辑。",
      "baiduC1Reference": "在提示词中通过 @名称 引用这张图片。",
      "baiduC1Prompt": "使用 @名称 引用 image_references 中同名素材。",
      "baiduPixVerseContent": "提供一条提示词，可选添加首帧和尾帧。",
      "baiduPixVerseStyle": "文生视频和单图生视频可用，首尾帧生成不支持。",
      "baiduPixVerseThinking": "文生视频是否使用系统优化提示词；省略时由模型决定。",
      "baiduHailuoFirstFrame": "首帧图片的公网 URL。",
      "baiduKlingFirstFrame": "首帧图片的 Base64 编码。",
      "baiduKlingLastFrame": "尾帧图片的 Base64 编码。",
      "baiduOmniContent": "提供提示词，可选添加参考图片、首尾帧或一个参考视频。",
      "baiduOmniImageBase64": "图片的 Base64 编码。",
      "grokTaskContent": "提供提示词、首帧、参考图片或一个用于编辑/延展的源视频；单张首帧生成可省略提示词。",
      "grokVideoAction": "选择 edit 编辑整个视频，或选择 extend 从末尾继续生成。",
      "grokNativeGeneration": "生成视频；首帧生成可省略提示词，参考图片最多七张且视频最多十秒。",
      "grokNativeEditing": "编辑源视频，保持源视频时长、比例与分辨率，输出最高720p。",
      "grokNativeExtension": "从源视频末尾继续生成2–10秒，输出包含原视频与新增片段，保持源视频比例与分辨率。",
      "grokOmniContent": "可组合首尾帧、片内关键帧、参考图片与音色；未提供任何帧时必须提供提示词。片内关键帧的 timestamp 以秒为单位。",
      "grokPrompt": "描述主体、动作、镜头运动和视觉风格。",
      "grokFrameInput": "可作为首帧、尾帧，或作为参考图片参与全能参考生成。",
      "grokPinnedFrame": "用 timestamp 指定图片在视频内出现的秒数。",
      "grokFrameTimestamp": "片内时间，必须小于 duration；关键帧按 1/3 秒取整后不能重叠。",
      "grokVoiceReferences": "xAI 预设音色 ID；提示词中可依次使用 <AUDIO_0>、<AUDIO_1>、<AUDIO_2>。",
      "grokReferenceResolution": "参考图片、音色、尾帧或片内关键帧模式最高支持 720p。",
      "grokKeyframes": "最多四个片内关键帧；时间必须大于 0 且小于 duration，不能落入同一个 1/3 秒时间格。",
      "grokSevenReferences": "按顺序提供最多七张参考图片。",
      "grokFourteenReferences": "按顺序提供最多十四张参考图片。",
      "grokThreeVoices": "按顺序提供最多三个 xAI 预设音色 ID。",
      "speechBinaryOutput": "HTTP 响应体为原始音频二进制，不是 JSON，也不是 Task 的 audios 数组。编码由 output_format 查询参数决定。",
      "speechVoicePath": "URL 路径中的声音 ID。",
      "speechTextInput": "提供一段需要合成为语音的文本。",
      "speechNativeText": "需要合成为语音的文本。",
      "speechNativeModel": "使用的模型 ID，可通过 GET /v1/models 查询。模型必须支持语音合成，可检查 can_do_text_to_speech 属性。",
      "speechNativeLanguage": "用于指定模型语言和文本标准化语言的 ISO 639-1 代码；模型不支持时会忽略。multilingual_v2 模型不支持此参数。",
      "speechNativeVoiceSettings": "覆盖该音色已保存的设置，仅影响本次请求。",
      "speechNativeStability": "控制音色稳定性和生成随机性。较低值提供更丰富的情绪，较高值可能使声音更单调。",
      "speechNativeSpeakerBoost": "提高与原说话者的相似度，同时增加计算开销和延迟。",
      "speechNativeSimilarity": "控制生成声音与原始音色的相似程度。",
      "speechNativeStyle": "增强原说话者的风格。非零值会增加计算开销，并可能增加延迟。",
      "speechNativeSpeed": "控制语速，默认 1.0；小于 1.0 放慢，大于 1.0 加快。",
      "speechNativeDictionaries": "按顺序应用的发音词典引用，包含 id 和 version_id；每次请求最多三个。",
      "speechNativeDictionaryId": "发音词典 ID。",
      "speechNativeDictionaryVersion": "发音词典版本 ID；省略时使用最新版本。",
      "speechNativeSeed": "指定种子后，上游会尽力让相同种子和参数产生相同结果，但不保证完全一致。取值为 0–4294967295 的整数。",
      "speechNativePreviousText": "当前文本之前的文本，用于改善多个语音片段拼接或本次生成的连贯性。",
      "speechNativeNextText": "当前文本之后的文本，用于改善多个语音片段拼接或本次生成的连贯性。",
      "speechNativePreviousIds": "此前生成片段的 request_id，最多三个，用于改善跨请求的语音连贯性。使用相同模型效果更好；与 previous_text 同时提供时会忽略 previous_text。",
      "speechNativeNextIds": "后续片段的 request_id，最多三个，可改善重新生成片段的连贯性。例如重新生成第二段时，可传入第三段 ID，并将第一段 ID 作为 previous_request_id。使用相同模型效果更好；与 next_text 同时提供时会忽略 next_text。",
      "speechNativeIvc": "是否使用专业音色的 IVC 版本，可改善表现力并减少延迟。",
      "speechNativeNormalization": "控制文本标准化：auto 由上游决定，on 始终启用，off 跳过。例如将数字转换成口语表达。",
      "speechNativeLanguageNormalization": "控制语言文本标准化，以改善发音。目前只支持日语，可能显著增加请求延迟。",
      "speechNativeLogging": "enable_logging=false 启用零留存模式，请求历史和语音拼接等功能将不可用；该模式仅供企业客户使用。",
      "speechNativeFormat": "音频编码格式为 codec_sample_rate_bitrate，例如 mp3_22050_32。192kbps MP3 需 Creator 或更高套餐；44.1kHz PCM/WAV 需 Pro 或更高套餐。μ-law（亦称 mu-law/u-law）常用于 Twilio 音频输入。",
      "speechNativeApiKey": "填写 Nexra API Key；网关使用已配置的渠道凭证访问上游。",
      "speechNativeBase64": "Base64 编码的音频数据。",
      "speechNativeAlignment": "原始文本中每个字符的时间戳。",
      "speechNativeNormalizedAlignment": "标准化文本中每个字符的时间戳。"
    }
  },
  "exports": {
    "currentScope": "导出当前筛选范围",
    "currentScopeHelp": "使用用量统计中已应用的全部筛选条件，生成 Excel 汇总与明细。",
    "export": "导出",
    "emptyRecords": "还没有导出记录，可通过用量统计页的导出按钮生成文件。",
    "startTime": "开始时间",
    "deletingRecord": "正在删除导出记录",
    "deleted": "导出记录已删除",
    "deleteFailed": "删除失败",
    "retryLater": "请稍后重试",
    "preparingDownload": "正在准备下载",
    "downloadWait": "完成后会自动下载，请勿重复点击",
    "downloadStarted": "下载已开始",
    "generateFailed": "导出生成失败",
    "retrySmaller": "请重试或缩小统计区间",
    "retryDownload": "重试下载",
    "download": "下载",
    "deleteTitle": "删除导出记录",
    "confirmDelete": "确认删除",
    "generatingFile": "正在生成导出文件",
    "autoDownload": "完成后会自动下载",
    "cannotExport": "无法导出",
    "unconfirmed": "请选择匹配项、确认 ID 或清空未确认的输入",
    "dateRequired": "请填写完整的统计区间",
    "dateOrder": "开始时间必须早于结束时间",
    "dateLimit": "一次最多导出 366 天，请缩小统计区间",
    "format": "格式",
    "range": "统计区间",
    "createdAt": "创建时间",
    "status": "状态",
    "actions": "操作",
    "title": "导出记录",
    "exportUsage": "导出用量",
    "exportDownload": "导出并下载",
    "endTime": "结束时间",
    "loading": "正在加载导出记录…",
    "loadFailed": "记录加载失败，请刷新重试。",
    "empty": "还没有导出记录；使用上方表单导出并下载。",
    "queued": "待下载",
    "processing": "生成中",
    "succeeded": "已生成",
    "failed": "失败",
    "expired": "已过期",
    "modelCount": "{{count}} 个模型",
    "userCount": "{{count}} 个用户",
    "deleteDescription": "确认删除记录 {{id}}？删除后不可恢复，已下载到本机的文件不受影响。"
  },
  "filters": {
    "user": "用户",
    "userAccount": "用户账号",
    "exportModelsPlaceholder": "留空全部；搜索模型或 ID，多选用逗号分隔",
    "exportUsersPlaceholder": "留空全部；搜索邮箱、用户名或 ID，多选用逗号分隔",
    "selectionLimit": "最多选择 {{count}} 项，请先移除部分已选项。",
    "invalidIds": "请输入有效的内部 ID，一次最多 {{count}} 项。",
    "missingIds": "未找到以下 ID：{{ids}}。请检查后重新确认。",
    "confirmFailed": "ID 确认失败，请重试。",
    "search": "搜索{{name}}",
    "select": "选择{{name}}",
    "options": "{{name}}筛选选项",
    "selectedCount": "已选 {{count}} 项",
    "searchOrBrowse": "输入搜索或查看列表",
    "selectedOnly": "已选",
    "clearSelection": "清除选择",
    "list": "{{name}}列表",
    "confirming": "确认中…",
    "confirmIds": "确认输入的 ID",
    "viewSelected": "查看已选{{name}}，{{count}} 项",
    "selected": "已选{{name}}",
    "itemCount": "{{count}} 项",
    "remove": "移除 {{name}}"
  },
  "channels": {
    "modelManagement": "模型管理",
    "credentialsExpired": "凭证已过期",
    "credentialsInvalid": "凭证异常",
    "connectionError": "连接异常",
    "lastCheckPassed": "上次检查通过",
    "notChecked": "尚未检查",
    "apiKey": "API 密钥",
    "bearerToken": "访问令牌",
    "serviceAccount": "服务账号 JSON",
    "edit": "编辑渠道",
    "add": "添加渠道",
    "editDescription": "管理渠道的连接信息、密钥和可用模型。",
    "addDescription": "选择渠道类型，配置连接信息和可用模型。",
    "closeEditor": "关闭渠道编辑",
    "type": "渠道类型",
    "custom": "自定义 · 第三方 / 私有部署",
    "typeImmutable": "渠道类型创建后不可更改。",
    "typeHelp": "选择官方服务或自定义兼容接口。",
    "name": "渠道名称",
    "namePlaceholder": "例如：生产环境主渠道",
    "customHelp": "自定义渠道支持 OpenAI 兼容接口；Anthropic 类型使用官方服务地址。",
    "enable": "启用此渠道",
    "enabledHelp": "允许使用此渠道",
    "disabledHelp": "暂时停用，保留配置",
    "maxActiveJobs": "异步任务并发上限",
    "maxActiveJobsPlaceholder": "留空表示不限制",
    "maxActiveJobsHelp": "只限制此渠道的异步任务；留空则不排队。",
    "invalidMaxActiveJobs": "并发上限必须是大于 0 的整数",
    "connectionCredentials": "连接与密钥",
    "apiAddress": "API 地址",
    "defaultAddress": "默认使用官方地址；接入第三方服务时可替换。使用 HTTPS，不含密钥或具体模型路径。",
    "savedCredentials": "✓ 已保存密钥",
    "missingCredentials": "待配置密钥",
    "missingCredentialsHelp": "此渠道已从测试环境推广；填写密钥后保存，再验证并启用。",
    "keepCredentialsHelp": "无需重新输入；填写新密钥后才会替换。",
    "keepAccount": "留空保留现有服务账号",
    "accountPlaceholder": "粘贴完整的 Google 服务账号 JSON",
    "keepSecret": "留空保留现有密钥",
    "secretPlaceholder": "渠道提供的密钥",
    "hideInputSecret": "隐藏输入的密钥",
    "showInputSecret": "显示输入的密钥",
    "hideSecret": "隐藏密钥",
    "showSecret": "显示密钥",
    "saveApplies": "连接与模型选择在保存后生效",
    "encrypted": "密钥将加密保存",
    "saving": "正在保存…",
    "save": "保存渠道",
    "syncingModels": "正在同步上游模型",
    "modelsSynced": "上游模型已同步",
    "syncFailed": "同步上游模型失败",
    "retryLater": "请稍后重试",
    "importing": "正在导入模型",
    "modelImported": "模型已导入",
    "importFailed": "模型导入失败",
    "modelsDescription": "同步上游列表，选择此渠道允许使用的模型。",
    "syncing": "正在同步…",
    "resync": "重新同步",
    "sync": "同步上游模型",
    "syncPersists": "同步立即保存列表；新供给默认停用，取消编辑不会撤销同步。",
    "notSynced": "尚未同步上游列表",
    "noDiscovery": "此渠道没有可用的模型列表接口，可以选择已配置项或手动录入上游 Model ID。",
    "saveBeforeSync": "先保存连接与密钥，之后即可同步上游列表；也可以先手动录入上游 Model ID。",
    "connectionChanged": "连接信息已经修改，请先保存渠道，再从新地址同步模型。",
    "searchModels": "搜索渠道模型",
    "searchModelsPlaceholder": "模型 ID 或名称",
    "selectResults": "全选搜索结果",
    "selectAll": "全选",
    "clearAll": "清除全部",
    "loadingModels": "正在读取已保存的模型…",
    "selectedModels": "已选择的模型",
    "supportedModels": "渠道支持的模型",
    "unmatched": "尚未匹配代码模型",
    "import": "导入",
    "confirmImport": "确认导入",
    "imported": "已导入",
    "discovered": "上游发现",
    "manual": "手动添加",
    "noMatchedModels": "没有匹配的模型",
    "emptyModels": "还没有模型，请同步上游模型或手动添加。",
    "importedMappings": "已导入的模型映射",
    "upstreamModel": "上游模型",
    "nexraModel": "Nexra 模型",
    "costStatus": "成本状态",
    "pendingProtocols": "已导入，待确认端点协议",
    "configured": "已配置",
    "missing": "待补充",
    "manualIds": "手动录入上游 Model ID",
    "manualHelp": "适用于上游不提供模型列表，或使用自定义部署名称的情况。",
    "manualPlaceholder": "上游 Model ID，多个用逗号分隔",
    "upstreamRouting": "上游路由",
    "supplyDescription": "选择上游渠道和模型，并配置公开端点的主备关系与权重。",
    "credentialOperationFailed": "凭证操作失败",
    "saveFailed": "渠道保存失败",
    "saved": "渠道已保存",
    "checkingConnection": "正在检查渠道连接",
    "checkFailed": "渠道检查失败",
    "connectionHealthy": "渠道连接正常",
    "connectionUnhealthy": "渠道连接异常",
    "channelProvider": "渠道 / 提供商",
    "models": "模型",
    "connection": "连接",
    "credentials": "凭证",
    "hidePlaintext": "隐藏明文凭证",
    "showPlaintext": "显示明文凭证",
    "checking": "正在检查",
    "checkRetry": "检查失败，请重试",
    "maintain": "维护渠道",
    "checkPending": "检查中…",
    "check": "检查连接",
    "verifyViaModel": "请通过已接入模型的实测验证渠道连接",
    "noIndependentCheck": "不支持独立检查",
    "create": "＋ 新建渠道",
    "search": "搜索渠道",
    "searchPlaceholder": "渠道、提供商或 API 地址",
    "allProviders": "全部提供商",
    "allStatuses": "全部状态",
    "enabled": "已启用",
    "degraded": "异常",
    "disabled": "已停用",
    "noMatches": "没有匹配的渠道",
    "copied": "凭证已复制",
    "copyPlaintext": "复制明文凭证",
    "copy": "复制凭证",
    "region": "区域",
    "mediaStorageRegion": "生成内容存储区域",
    "mediaStorageRegionHelp": "决定图片和视频生成结果存入国内桶或全球桶，请按数据存储要求选择。",
    "mediaStorageRegionCn": "国内桶（cn）",
    "mediaStorageRegionGlobal": "全球桶（global）",
    "openaiCompatible": "OpenAI 兼容接口",
    "compatibleAddress": "填写服务的 API 根地址，例如 https://ai.example.com/v1。适用于兼容 OpenAI 的第三方服务和私有部署。",
    "azureAddress": "填写 Azure 资源地址，例如 https://your-resource.openai.azure.com，不含具体部署路径。",
    "foundryAddress": "填写 Foundry 项目地址，例如 https://your-resource.services.ai.azure.com/api/projects/your-project。",
    "projectId": "项目 ID",
    "location": "区域 / Location",
    "workspaceId": "工作区 ID",
    "awsClaudeAddress": "填写 Claude on AWS 提供的接入地址。",
    "bedrockAddress": "填写所选区域的 Bedrock Runtime 地址；本接入类型使用 Bedrock API Key。",
    "volcengineArk": "火山方舟",
    "volcengineSpeech": "火山语音",
    "alibabaBailian": "阿里云百炼",
    "h3Address": "填写 H3 自部署服务根地址。支持 HTTP 或 HTTPS；HTTP 会以明文传输 session。",
    "h3PartnerAddress": "填写 H3 Partner API 服务根地址。支持 HTTP 或 HTTPS。",
    "incompleteCredentials": "请完整填写这组密钥；保留原密钥时请全部留空。",
    "invalidServiceAccount": "服务账号 JSON 需要包含 project_id、client_email 和 private_key。",
    "recognizedAccount": "已识别服务账号：{{email}}",
    "modelCount": "{{count}} 个模型",
    "importedHint": "{{id}}；请在模型供给中维护协议、状态与成本",
    "selectionLimit": "最多选择 5000 个模型，请缩小选择范围。",
    "invalidModelIds": "模型 ID 最长 320 个字符，最多选择 5000 个模型。",
    "selectedCount": "已选 {{count}} / {{total}} 个模型",
    "lastSynced": "上次同步 {{at}}",
    "resultsTruncated": "显示前 100 个结果；搜索可定位其他模型，全选会选择全部 {{count}} 个结果。",
    "removeModel": "移除 {{id}}",
    "selectModel": "选择 {{id}}",
    "moreSelected": "另有 {{count}} 个",
    "exactMatch": "精确匹配：{{id}}",
    "suggestedMatch": "候选：{{id}}",
    "configuredProtocols": "已配置协议：{{protocols}}",
    "partialList": "上游返回的可能是部分列表。",
    "selectionSaveHint": "勾选结果保存后生效。已导入模型的启停、协议与成本在模型管理中维护。",
    "checkStatus": "检查连接 · {{status}}"
  },
  "validity": {
    "indefinite": "长期有效",
    "active": "生效中",
    "soon": "即将生效",
    "upcoming": "未生效"
  },
  "overview": {
    "scrollUp": "{{label}}向上滚动",
    "scrollDown": "{{label}}向下滚动",
    "measured": "实测",
    "carried": "沿用上次结果",
    "expired": "已过期",
    "noObservation": "无观测",
    "none": "无",
    "collectionGap": " · 采集有缺口",
    "hourScroll": "每格 1 小时 · 可横向滚动",
    "hourNow": "每格 1 小时 · 现在",
    "legend": "图例",
    "measuredSuccess": "实测成功",
    "mixed": "成功与失败混合",
    "measuredFailure": "实测失败",
    "carriedSuccess": "沿用成功",
    "carriedFailure": "沿用失败",
    "unknownExpired": "未知 / 过期",
    "gapLegend": "虚线：采集缺口",
    "readFailed": "读取失败，未展示旧数据，请重试。",
    "unavailable": "运行数据暂不可用，请重试。",
    "loading": "正在读取运行记录…",
    "title": "平台运行全景",
    "refresh": "刷新指标",
    "registeredModels": "在册模型",
    "databaseTotal": "数据库全量统计",
    "activeChannels": "活跃供货渠道",
    "channelStates": "正常 {{normal}} · 异常 {{abnormal}} · 停用 {{disabled}}",
    "availabilityNote": "端点可用性见下方实测",
    "tasks24h": "24h 异步任务流",
    "recentErrors": "近期异常日志",
    "period24h": "24H",
    "period7d": "7 天",
    "sampleInterval": "每 30s 采样 · 每格 1 小时",
    "sampleSource": "采样环境：{{source}}",
    "noCore": "暂无核心服务观测",
    "activeTasks": "正在执行的长任务",
    "activeTasksWithCount": "{{label}}（总数 {{count}}）",
    "noRecentTasks": "暂无最近任务记录",
    "manageTasks": "任务管理 →",
    "taskList": "正在执行的长任务列表",
    "noTasks": "当前没有进行中的任务",
    "liveTail": "最新网关调用流水 (Live Tail)",
    "httpResponse": "HTTP 响应",
    "recentLink": "查看最近 →",
    "requestList": "最新网关调用流水列表",
    "channelProbes": "上游渠道实时探针",
    "manageChannels": "管理渠道 →",
    "probeList": "上游渠道实时探针列表",
    "channelRouteCounts": "{{models}} 个模型 · {{routes}} 条路线",
    "channelObservation": "渠道观测：{{state}}（业务请求与主动探测）",
    "probeReady": "可探测",
    "probeReadyCount": "{{ready}}/{{total}} 条路线可探测",
    "observedSuccess": "观测成功",
    "collapseProbes": "收起",
    "showProbes": "展开 {{count}} 条路线",
    "noTargets": "暂无模型渠道端点",
    "shortcuts": "快捷运维与策略入口",
    "pricingTitle": "全局销售定价策略",
    "pricingDescription": "维护基准倍率并一键重算发布销售价",
    "errorsTitle": "排查网关 4xx/5xx 错误",
    "errorsDescription": "诊断上游断流与超时请求",
    "monitoringBudget": "监测详情与探针预算",
    "noBudget": "未配置预算，自动付费探测不启用。",
    "monitoringHelp": "监测说明",
    "help": "说明",
    "historyWindow": "历史窗口",
    "last24h": "最近 24 小时",
    "last7d": "最近 7 天",
    "probeSubmitFailed": "探测提交失败",
    "retry": "请重试",
    "autoProbeEnabled": "自动探测已配置",
    "autoProbeDisabled": "自动探测关闭",
    "businessRate": "业务成功率",
    "probeRate": "主动探测成功率",
    "observationSummary": "{{label}} {{rate}} · {{count}} 次",
    "observationDetails": "观测详情",
    "configureTemplate": "配置模板",
    "runProbe": "执行探测",
    "history": "历史记录",
    "costRefreshing": "费用正在更新或读取失败，未展示旧金额",
    "costPaused": " · 费用待核对，已暂停",
    "probeReadFailed": "读取探测结果失败，请重试",
    "unknownCost": "未知费用",
    "probeHistoryLoading": "正在读取最新探测记录…",
    "noProbeHistory": "暂无探测记录",
    "saveFailed": "配置保存失败",
    "intervalSeconds": "无有效请求结果后的探测间隔（秒）",
    "timeoutSeconds": "总超时（秒）",
    "runBudget": "单次预算",
    "templateVersion": "模板版本",
    "enableProbes": "启用自动探测",
    "requestTemplateHelp": "固定请求模板（含必需参数与参考素材）",
    "requestTemplate": "请求模板",
    "maxUsageHelp": "最大用量（仅无法自动估算的模板需填写 normalized usage JSON）",
    "maxUsage": "最大用量",
    "saveConfig": "保存配置",
    "setBudget": "设置每日预算",
    "operationFailed": "操作失败",
    "cny": "人民币",
    "budgetCurrency": "预算币种",
    "dailyLimitCny": "每日上限（元）",
    "dailyLimit": "每日上限",
    "amountPlaceholder": "金额",
    "confirmCost": "核对实际费用",
    "upstreamCostPlaceholder": "核对上游实际费用",
    "settle": "确认结算",
    "noSamples": "无样本",
    "bucket": "{{start}} — {{end}} · {{evidence}} · 业务 {{businessSuccess}} 成功 / {{businessFailure}} 失败 · 探针 {{probeSuccess}} 成功 / {{probeFailure}} 失败 {{core}} · 最新证据 {{latest}}{{gap}}",
    "coreSamples": "· 核心 {{success}} 成功 / {{failure}} 失败（应采 {{expected}}）",
    "taskSummary": "成功率 {{rate}} · 取消 {{count}}",
    "recentRequestCount": "最近 5 分钟 · {{count}} 请求",
    "coreHealth": "核心服务与 {{period}} 遥测健康",
    "gatewaySummary": "QPS {{qps}} · 接口 P99 {{p99}}",
    "taskCounts": "{{running}} 正在执行 · {{queued}} 排队",
    "callbackCounts": "{{pending}} 待发送 · {{retrying}} 重试",
    "modelCount": "{{count}} 模型数据",
    "failureCount": "{{count}} 异常",
    "historySummary": "历史从 {{start}} 起 · 用户最终请求成功率 {{rate}}（{{count}} 样本 / 5 分钟）",
    "latencySummary": "接口响应耗时：P95 {{p95}} · P99 {{p99}} · 耗时样本 {{count}}；异步任务仅统计接口受理时间。",
    "callbackSummary": "Webhook：待发送 {{pending}} · 重试 {{retrying}} · 失败 {{failed}} · 24 小时实际送达 {{delivered}}",
    "budgetSummary": "{{currency}} · 每日上限 {{limit}} · 已结算 {{settled}} · 预留 {{reserved}}",
    "sparkline": "{{start}} — {{end}} · {{samples}} · 每 30s 采样{{gap}}",
    "sampleRate": "成功率 {{rate}}（{{success}}/{{count}}）",
    "notReady": "待配置 / 暂停：{{state}}",
    "probeInterval": "无有效请求结果后的探测间隔 {{hours}} 小时",
    "probeResult": "探测 {{id}} · {{status}} · {{stage}}",
    "reserved": "预留 {{amount}}",
    "upstreamTask": " · 上游 {{id}}",
    "stats": "{{label}} {{rate}} · {{samples}} 样本 / {{hours}} 小时 · 限流 {{limited}} · 地域限制 {{restricted}} · 排除 {{excluded}}",
    "core": {
      "gateway": "Gateway 统一路由",
      "database": "Postgres 数据库",
      "restate": "Restate 异步编排",
      "webhook": "Webhook 执行链路"
    },
    "samplingInterrupted": "采样已中断",
    "historicalSampleRate": "历史样本成功率；灰色表示无样本"
  },
  "common": {
    "realtimeDisconnected": "实时更新连接已断开，当前显示上次读取的数据。",
    "newRecordsAvailable": "有新记录，刷新查看",
    "networkError": "网络连接失败，请稍后重试",
    "pagination": "列表分页",
    "pageNumber": "第 {{page}} 页",
    "refreshing": "正在刷新…",
    "loading": "正在加载数据…",
    "loadFailed": "加载失败",
    "copy": "复制",
    "copied": "已复制",
    "reset": "重置",
    "more": "展开",
    "less": "收起",
    "selectPlaceholder": "请选择",
    "dash": "—",
    "default": "默认",
    "on": "开",
    "off": "关",
    "automatic": "自动",
    "choose": "选择",
    "randomUnset": "随机（不传）",
    "noCompressionUnset": "不压缩（不传）",
    "followInputUnset": "不指定（跟随输入图）",
    "unspecified": "不指定",
    "setField": "设置{{title}}。"
  },
  "usageDocs": {
    "title": "用量接口参考",
    "toc": "本页目录",
    "endpoint": "接口",
    "description": "说明",
    "parameter": "参数",
    "rule": "使用规则",
    "field": "字段",
    "httpStatus": "HTTP 状态",
    "errorCode": "错误码",
    "sections": {
      "authentication": "鉴权与权限",
      "endpoints": "接口列表",
      "parameters": "查询参数",
      "fields": "返回字段",
      "examples": "请求与响应示例",
      "pagination": "分页与数据时效",
      "errors": "错误与处理"
    },
    "authentication": "有效管理员账号，邮箱已验证。",
    "keyScope": "全站只读查询；API Key 仍可调用模型。",
    "headers": "zh-CN / en，默认 en。",
    "endpointDescriptions": {
      "summary": "请求量、成功失败、Token/媒体用量及 CNY 金额；支持时间和模型/API Key 分组。",
      "details": "逐请求归属、用量证据、结算金额和明细，支持游标分页。",
      "anomalies": "计费异常数量，可按模型、渠道、供应商拆分。"
    },
    "parameterDescriptions": {
      "start": "必填，ISO-8601 时刻，含时区，小数秒最多三位。按请求接收时间匹配，包含 start。",
      "end": "必填，晚于 start，不包含 end；区间最多 {{maxDays}} 天。",
      "timeZoneOffsetMinutes": "整数 -720..840，默认 0（UTC）；UTC+08:00 传 480。只影响时间桶。",
      "groupBy": "summary 必填：{{groups}}。最多一个时间粒度，不可重复。",
      "limit": "summary：1..{{summaryLimit}}；details：1..{{detailsLimit}}；默认 {{defaultLimit}}。",
      "cursor": "仅 summary/details；第一页省略，下一页传 nextCursor，其余条件相同。",
      "userIds": "账号 ID 列表，最多 {{filterLimit}} 项。",
      "apiKeyIds": "API Key 数据库 UUID 列表，最多 {{filterLimit}} 项。",
      "providerIds": "供应商数据库 UUID 列表，最多 {{filterLimit}} 项。",
      "channelIds": "渠道数据库 UUID 列表，最多 {{filterLimit}} 项。",
      "modelIds": "模型数据库 UUID 列表，最多 {{filterLimit}} 项。",
      "operations": "操作名列表，如 language.generate，最多 {{filterLimit}} 项。",
      "requestStatuses": "received / accepted / running / succeeded / rejected / failed / cancelled，最多 {{filterLimit}} 项。",
      "usageSources": "{{sources}}。estimated 不计入报表。",
      "normalizationStatuses": "{{normalization}}。partial 为保留状态。",
      "ratingStatuses": "{{rating}}。",
      "upstreamModelId": "单个准确的上游模型 ID。",
      "breakdown": "仅异常概览：provider / channel / model，最多两个。"
    },
    "fieldDescriptions": {
      "group": "本行分组维度；time 为 UTC 时间桶起点，其他身份字段使用数据库 ID。",
      "requests": "total/succeeded/failed 计数。受理或运行中计入 total；取消和必需资源交付失败计入 failed。",
      "usage": "证据存在与缺失数、来源及归一化状态数量。缺失证据不代表用量为零。",
      "rating": "billed/unsettled/billing_failed/unpriced/usage_missing 数量。billed 可包含已退款账单，经营金额仅累计成功结算账单。",
      "tokens": "requestsWithTokenMetrics 为有 Token 证据的请求数；带时间桶或未按模型分组时 applicable 为 null，false 表示该模型没有适用的 Token 价格。",
      "metrics": "各归一化计量项合计，跨计量维度相加。未出现的键表示未计量或不适用，明确出现 0 才表示实际计量为零。",
      "amounts": "sale/cost/gross 的 CNY 金额，amount 为最多八位小数的十进制字符串。仅累计成功结算，未知成本或汇率不补零；只有 gross 可为负。",
      "costReporting": "reported/missingCost/missingRate 表达成功结算账单的采购成本和冻结汇率覆盖情况。",
      "nextCursor": "summary/details 完成时为 null；否则按相同条件继续请求下一页。空窗口返回 data: []。",
      "details": "明细行包括 requestId/requestKey、接收时间、状态、HTTP/时长/错误上下文、账号/Key/模型/路由归属、usage 和可空 charge。usage 含 rawUsage/normalizedUsage；charge 含十进制金额、冻结报表汇率、discountBps 和 breakdown。",
      "categories": "异常类别、数量、首次及末次出现时间。usage_missing 仅适用于已成功请求，与汇总 usage.missing 可不同。",
      "breakdowns": "按所选维度返回异常类别、dimension、可空 dimensionId 及数量。"
    },
    "exampleTitles": {
      "summary": "汇总响应",
      "details": "明细响应",
      "anomalies": "异常概览响应"
    },
    "pagination": "无跨页快照；近期窗口重复查询后覆盖旧统计。",
    "freshness": "用量和结算异步更新；已结算使用冻结证据，未结算使用当前执行证据。",
    "account": "账号",
    "permissions": "权限",
    "authHeader": "Bearer <API Key> 或 x-api-key: <API Key>。",
    "baseUrl": "API 地址，不带末尾斜杠。",
    "apiKey": "管理员 API Key。",
    "snapshot": "分页快照",
    "dataFreshness": "数据时效",
    "timeBuckets": "时间桶",
    "sparseBuckets": "无请求的时间桶不返回。"
  },
  "documentation": {
    "navigation": "文档目录"
  },
  "nav": {
    "documentation": "API 文档",
    "usageDocs": "用量接口",
    "errorDocs": "错误参考",
    "homeAria": "Nexra 首页",
    "mainAria": "主导航",
    "home": "首页",
    "playground": "体验",
    "models": "模型",
    "requests": "请求记录",
    "admin": "管理后台",
    "login": "登录",
    "settings": "设置",
    "signOut": "退出登录",
    "language": "界面语言",
    "languageZh": "中文",
    "languageEn": "English",
    "accountMenu": "账号菜单",
    "apiKeys": "API 密钥",
    "signedInAs": "当前账号",
    "loginEntry": "登录"
  },
  "auth": {
    "wechatWaiting": "请在新窗口中使用微信扫码登录。",
    "socialPopupBlocked": "请允许浏览器弹出授权窗口后重试。",
    "socialFailed": "登录失败，请重试。",
    "socialExpired": "本次授权已过期，请重新登录。",
    "socialNotConfigured": "登录服务暂未配置，请联系管理员。",
    "socialSecurity": "安全授权登录，无需设置密码",
    "socialCreateAccount": "首次登录将自动创建账号。",
    "socialProductDescription": "图像、视频与语言模型，在这里汇聚。",
    "socialHeadline": "一个入口，\n连接更多灵感。",
    "socialDescription": "选择你习惯的方式，继续创作。",
    "socialTitle": "登录 Nexra",
    "wechatSignIn": "使用微信登录",
    "googleSignIn": "使用 Google 登录",
    "googleWaiting": "请在新窗口中完成 Google 授权。",
    "signInTitle": "登录控制台",
    "signUpTitle": "创建账号",
    "description": "模型、任务和请求数据只对当前账号可见。",
    "name": "名称",
    "email": "邮箱",
    "password": "密码",
    "submitting": "提交中…",
    "signIn": "登录",
    "signUp": "注册",
    "needAccount": "没有账号？注册",
    "haveAccount": "已有账号？登录",
    "feishuSignIn": "{{enterprise}} · 飞书登录",
    "feishuWaiting": "请在新窗口中使用对应企业的飞书账号授权。",
    "feishuEmployeeRequired": "请使用所选企业的有效在职员工账号，并确认已获应用使用权限。",
    "feishuUnavailable": "企业飞书登录暂不可用，请稍后重试或联系应用负责人。",
    "cancelFeishu": "取消飞书登录"
  },
  "dashboard": {
    "title": "首页",
    "welcomeBack": "欢迎回来，{{name}}",
    "guestWelcome": "开始体验 Nexra 的模型能力",
    "quickStart": "快速开始",
    "quickStartHint": "从已经接入并可运行的模型开始。",
    "createTitle": "使用 AI 开始创作",
    "createHint": "无需编写接入代码，直接运行已接入的任务模型。",
    "sandboxTitle": "Nexra 体验",
    "sandboxHint": "配置并运行媒体生成任务",
    "browseTitle": "浏览全部模型",
    "browseHint": "查看模型目录和参数定义",
    "recentTitle": "最近记录",
    "recentHint": "查看请求、耗时和错误",
    "signInTitle": "登录控制台",
    "signInHint": "查看任务、请求和用量",
    "exploreTitle": "探索最新模型",
    "exploreHint": "查看模型目录中最新发布的能力定义。",
    "browseAllHint": "搜索所有已发布模型",
    "noPublished": "暂无已发布模型",
    "shelfAria": "首页模型",
    "latestModels": "✦ 最新模型",
    "recentlyUsed": "↻ 最近使用",
    "viewAll": "查看全部 →",
    "noRecent": "暂无最近使用的模型",
    "noRecentDetail": "在体验中运行模型后会显示在这里。",
    "latestResults": "最新生成结果",
    "latestResultsHint": "最近的图片、视频和音频任务结果。",
    "showPreview": "显示预览",
    "previewHidden": "生成预览已隐藏，可前往请求记录查看。",
    "noResults": "暂无生成结果",
    "noResultsDetail": "前往体验运行第一个模型。"
  },
  "notFound": {
    "title": "页面不存在",
    "detail": "返回首页继续浏览。",
    "backHome": "返回首页"
  },
  "explore": {
    "title": "模型",
    "modelCount": "{{count}} 个模型",
    "modelCount_one": "{{count}} 个模型",
    "modelCount_other": "{{count}} 个模型",
    "subtitle": "浏览模型能力、API 文档与价格。",
    "searchPlaceholder": "搜索模型名称、ID 或能力...",
    "sortAria": "排序方式",
    "sortName": "模型名称 (A-Z)",
    "all": "全部",
    "audioTab": "语音与音频",
    "emptyTitle": "未找到符合条件的模型",
    "emptyDetail": "请尝试清除筛选条件或更换搜索关键词。",
    "resetFilters": "重置所有筛选",
    "inputTypes": "输入类型",
    "developers": "开发者",
    "text": "文本",
    "image": "图片",
    "video": "视频",
    "audio": "音频",
    "file": "文件",
    "showMore": "显示更多",
    "showLess": "收起",
    "sortDefault": "默认排序",
    "copyModelId": "复制模型 ID",
    "copyFailed": "复制模型 ID 失败",
    "modelSummary": "{{name}} · {{operation}}",
    "outputTypes": "输出类型",
    "protocols": "协议",
    "unavailable": "暂无可用端点",
    "endpointCount": "{{count}} 个端点",
    "endpointCount_one": "{{count}} 个端点",
    "endpointCount_other": "{{count}} 个端点",
    "pricing": "价格",
    "apiDocs": "API 文档",
    "details": "查看详情",
    "successHistory": "最近 24 小时请求成功率",
    "successRate": "24 小时成功率",
    "noRequests": "无请求",
    "noStatistics": "暂无统计",
    "successSample": "{{rate}}% · {{succeeded}} / {{total}} 次请求",
    "filters": "模型筛选",
    "selectedFilters": "模型筛选，已选 {{count}} 项",
    "modelType": "模型分类"
  },
  "studio": {
    "videoOutputChoice": "输出视频",
    "videoOutputNumber": "视频 {{number}}",
    "videoOutputRoles": {
      "mask": "黑白遮罩",
      "tracking-preview": "彩色追踪预览"
    },
    "tabs": {
      "playground": "体验",
      "api": "API 文档",
      "examples": "示例",
      "pricing": "价格",
      "requests": "调用记录"
    },
    "input": "输入",
    "result": "结果",
    "form": "表单",
    "preview": "预览",
    "inputView": "输入视图",
    "jsonInput": "JSON 输入",
    "jsonObjectRequired": "请输入 JSON 对象，不能是数组、文本、数字、布尔值或 null。",
    "jsonSyntaxError": "JSON 格式不正确，请检查引号、逗号和括号。",
    "editMultipleMessagesJson": "多条消息请在 JSON 中编辑。",
    "codeExample": "代码示例（只读）",
    "copy": "复制",
    "copied": "已复制",
    "copyUrl": "复制链接",
    "copyModelId": "复制模型 ID",
    "favorite": "收藏",
    "unfavorite": "已收藏",
    "openInSandbox": "体验",
    "download": "下载",
    "run": "运行",
    "reset": "重置",
    "generating": "生成中…",
    "taskReadRetrying": "暂时无法读取任务状态，正在自动重试。请勿重复提交。",
    "taskReadUnavailable": "暂时无法读取任务状态，请刷新重试。请勿重复提交。",
    "ready": "等待运行",
    "completed": "已完成",
    "failed": "失败",
    "additionalSettings": "更多参数",
    "more": "展开",
    "less": "收起",
    "prompt": "提示词",
    "duration": "时长",
    "approximateDuration": "约 {{value}} {{unit}}",
    "fixedDuration": "固定{{value}}",
    "resolution": "分辨率",
    "seedanceDraft": "Draft 样片（480p）",
    "seedanceDraftHint": "先生成 480p 样片；样片和后续 1080p 正式版是两次独立付费任务。",
    "seedanceDraftReady": "样片已生成",
    "seedanceDraftBilling": "可在 7 天内基于这条样片生成 1080p 正式版；会沿用原渠道，并作为另一条任务单独计费。",
    "seedanceGenerateFinal": "生成 1080p 正式版",
    "seedanceDraftExpired": "样片已过期，请重新生成",
    "aspectRatio": "画面比例",
    "automatic": "自动",
    "imageBadge": "图",
    "videoBadge": "视频",
    "audioBadge": "音频",
    "outputHint": "调整左侧参数后，点击“运行”开始生成。",
    "waitingForResult": "请求处理中，结果会显示在这里。",
    "chargedByUsage": "费用按实际用量结算。",
    "requestDuration": "请求耗时 {{duration}}",
    "version": "版本",
    "switchVersion": "切换模型版本",
    "modelDescriptionFallback": "{{name}}，支持{{modality}}能力。",
    "schema": "参数结构",
    "analytics": "统计",
    "modelDetails": "模型详情",
    "videoFailed": "视频生成失败",
    "noVideo": "未返回视频",
    "imageFailed": "图片生成失败",
    "noImage": "未返回图片",
    "llmsTxt": "LLMs.txt",
    "openLlmsTxt": "打开 LLMs.txt",
    "resultView": "结果视图",
    "pause": "暂停",
    "play": "播放",
    "muted": "静音中",
    "audioOn": "原生音效已开启",
    "saveOrShare": "保存或分享结果",
    "close": "关闭",
    "zoomPreview": "放大预览",
    "generatedImage": "生成的图片",
    "generatedVideo": "生成的视频",
    "viewOriginal": "查看原图",
    "generatingImage": "正在生成图片…",
    "generatingVideo": "正在生成视频…",
    "replyPlaceholder": "追加后续对话或追问…",
    "reply": "后续对话",
    "sendReply": "发送追问",
    "replyFailed": "发送失败，请重试。",
    "toolCall": "工具调用",
    "receivingToolName": "正在接收工具名…",
    "toolExecuted": "已执行",
    "toolPending": "请求调用 · 尚未执行",
    "thoughtProcess": "思考过程",
    "generatingResponse": "正在生成响应…",
    "videoPoster": "视频预览",
    "generatedImageNumber": "生成图片 {{count}}",
    "promptPlaceholder": "描述你想生成或编辑的视频…",
    "resetDuration": "重置时长",
    "firstFrame": "首帧图片",
    "lastFrame": "尾帧图片",
    "pasteImageUrl": "粘贴图片链接",
    "uploadOrPasteImage": "上传图片或粘贴链接",
    "uploading": "上传中…",
    "addImage": "添加图片",
    "remove": "移除",
    "removeImage": "移除此图片",
    "removeAudio": "移除此音频",
    "removeVideo": "移除此视频",
    "hint": "提示",
    "mediaHint": "支持拖放图片、粘贴剪贴板内容或输入链接。文件格式：jpg、jpeg、png、webp、gif、avif、heic、heif。",
    "mediaHintShort": "支持拖放图片、粘贴剪贴板内容或输入链接。",
    "cameraMotion": "镜头运动",
    "fixedCamera": "固定镜头",
    "additionalHint": "配置非必填的模型参数。",
    "hashHint": "使用 # 引用输入素材，使用 @ 引用实体。",
    "mentionHint": "点击素材，插入 @引用。",
    "refImages": "参考图",
    "referenceAssets": "参考素材",
    "addMedia": "添加素材",
    "dropReferenceMedia": "也可拖入图片、视频或音频。",
    "unsupportedMedia": "此模型不支持该文件类型。",
    "mediaCapacityReached": "已达到素材数量上限，请移除部分素材后再添加。",
    "previewAsset": "预览 {{name}}",
    "refVideos": "参考视频",
    "refAudios": "参考音频",
    "refImagesHint": "人物、场景或风格参考，支持多张。",
    "refVideosHint": "参考运镜、动作或手势。",
    "refAudiosHint": "参考配乐、节奏或音效。",
    "pasteAssetUrl": "粘贴素材链接",
    "upload": "上传",
    "uploadImage": "上传图片",
    "uploadVideo": "上传视频",
    "uploadAudio": "上传音频",
    "dropOrPasteMedia": "点击选择，或拖放、粘贴文件",
    "dropOrPasteImage": "点击选择，或拖放、粘贴图片",
    "addUrl": "添加链接",
    "addMore": "继续添加",
    "replace": "替换",
    "uploadFailed": "上传失败，请重试",
    "assetCount": "{{count}} 个素材",
    "assetCount_one": "{{count}} 个素材",
    "assetCount_other": "{{count}} 个素材",
    "insertReference": "在提示词中插入引用",
    "insertReferenceNamed": "在提示词中插入 {{name}}",
    "generateAudio": "生成声音",
    "audioOnChip": "有声",
    "audioOffChip": "无声",
    "useAsReference": "用作参考视频",
    "framesMode": "首尾帧控制",
    "mediaMode": "参考方式",
    "refMode": "参考生成",
    "lastFrameNeedsFirst": "尾帧需要搭配首帧使用。",
    "attachment": "附件",
    "protocolEndpoint": "协议端点",
    "systemInstruction": "系统人设",
    "systemPlaceholder": "设置模型的角色与回答要求（可选）",
    "thinkingLevel": "思考强度",
    "addFile": "添加文件",
    "addUrlPlaceholder": "添加图片、文档或粘贴链接",
    "documentHint": "支持拖放图片或文档、粘贴剪贴板内容或输入链接。",
    "additionalLanguageHint": "系统人设、温度、Token 和推理设置",
    "attachmentUrl": "附件链接",
    "remoteAttachment": "远程资源",
    "attachmentImage": "图像分析",
    "attachmentPdf": "PDF 文档",
    "attachmentAudio": "音频输入",
    "attachmentsMessages": "支持图片和 PDF。可选择文件、拖放、粘贴或填写链接。",
    "attachmentsGemini": "支持图片、PDF、音频和视频。可选择文件、拖放、粘贴或填写链接。",
    "attachmentsImages": "支持图片。可选择文件、拖放、粘贴或填写链接。",
    "reasoningSummary": "显示推理摘要",
    "enableReasoning": "开启推理",
    "adaptiveThinkingHint": "勾选后使用自适应推理并返回摘要；未勾选时保留当前请求的思考模式。",
    "effortField": "推理强度（{{field}}）",
    "reasoningTokenBudget": "最大推理 Token 预算",
    "tokenCount": "{{value}} Token",
    "maxOutputTokens": "最大输出 Token 数",
    "omitTokenLimit": "不设置（不传）",
    "adaptiveTokenLimit": "包含推理和正文，上限 {{value}} Token。",
    "outputTokenHint": "仅调整本次请求的输出上限；上下文限制以模型为准。",
    "tokenRangeError": "请输入 {{min}}～{{max}} 的整数。",
    "sellingPoints": "模型卖点",
    "inputMode": {
      "text-to-video": "文生视频",
      "image-to-video": "图生视频",
      "video-to-video": "视频参考",
      "audio-to-video": "音频参考",
      "text-to-image": "文生图",
      "image-to-image": "图生图",
      "text-to-audio": "文生音频",
      "audio-to-audio": "音频编辑",
      "text-to-text": "文本生成"
    },
    "feature": {
      "max-duration-30s": "最长 30 秒",
      "multimodal-reference": "图 / 视频 / 音频参考"
    },
    "clearAll": "清空",
    "appendPhotos": "追加相片",
    "chooseOneImage": "选择一张参考图片",
    "batchImagesHint": "支持批量多选，每张图片独立展示（最多 {{count}} 张）",
    "maxImages": "最多 {{count}} 张图片",
    "uploadingCloud": "上传中…",
    "editMask": "编辑蒙版",
    "countFraction": "{{count}}/{{max}}",
    "addMoreShort": "添加",
    "addAudioCount": "添加音频 ({{count}}/{{max}})",
    "addVideoCount": "添加视频 ({{count}}/{{max}})",
    "mediaReady": "已就绪",
    "maskNeedsImage": "使用蒙版时请添加输入图片。"
  },
  "admin": {
    "navAria": "管理导航",
    "groups": {
      "overview": "概览",
      "supply": "模型与供货",
      "commercial": "商业化策略",
      "demand": "需求侧",
      "observe": "运行观测"
    },
    "links": {
      "overview": "运行全景",
      "models": "模型管理",
      "channels": "上游渠道",
      "pricingPolicy": "定价管理",
      "modelPrices": "模型价格参考",
      "wallets": "钱包与账务",
      "users": "用户管理",
      "usage": "用量统计",
      "finance": "财务统计",
      "usageExports": "导出记录",
      "requests": "调用记录",
      "errors": "异常与错误"
    },
    "mobileNav": "管理导航 · {{section}}",
    "shell": {
      "backToSite": "返回前台",
      "signInRequiredTitle": "请先登录",
      "signInRequiredDetail": "登录后才能访问管理后台。",
      "forbiddenTitle": "无权访问管理后台",
      "forbiddenDetail": "当前账号没有管理后台权限，请使用管理员账号登录。"
    }
  },
  "modality": {
    "language": "文本",
    "image": "图片",
    "video": "视频",
    "audio": "音频",
    "world": "世界模型",
    "embedding": "嵌入",
    "reranker": "重排序",
    "multimodal": "多模态",
    "other": "其他"
  },
  "status": {
    "error": "错误",
    "warning": "警告",
    "unknown": "未知",
    "active": "启用",
    "disabled": "停用",
    "archived": "已归档",
    "healthy": "正常",
    "degraded": "异常",
    "unavailable": "上游暂不可用",
    "invalid": "无效",
    "ready": "可用",
    "pending_configuration": "待配置探针",
    "route_disabled": "路线已停用",
    "requires_task_endpoint": "需使用任务端点探测",
    "missing_price": "缺少进价",
    "invalid_price": "进价配置无效",
    "missing_usage_ceiling": "缺少用量上限",
    "single_probe_budget_exceeded": "超出单次探测预算",
    "unknown_cost": "费用待核对，探测已暂停",
    "budget_exceeded": "探测费用超出预算",
    "public": "公开",
    "private": "私有",
    "draft": "草稿",
    "published": "已发布",
    "retired": "已停用",
    "pending": "待处理",
    "queued": "排队中",
    "running": "运行中",
    "succeeded": "成功",
    "first_response": "第一次响应",
    "delivery_failed": "保存失败",
    "failed": "失败",
    "rejected": "已拒绝",
    "cancelled": "已取消",
    "accepted": "已接受",
    "received": "已接收",
    "delivered": "已送达",
    "retrying": "重试中",
    "expired": "已过期",
    "revoked": "已撤销",
    "verified": "已确认",
    "needs_correction": "需修正",
    "durable": "已持久化",
    "temporary": "临时",
    "cancelling": "正在取消",
    "canceled": "已取消",
    "submitted": "已提交",
    "processing": "处理中",
    "polling": "轮询中",
    "uploading": "上传中",
    "completed": "已完成",
    "storing": "正在持久化",
    "persisted": "已持久化",
    "unlisted": "不公开列出",
    "deprecated": "已弃用",
    "needs route": "待接入端点",
    "live": "在线",
    "verification_required": "需要验证"
  },
  "pricing": {
    "fps_band": "源视频帧率",
    "cache_creation_5m_input_tokens": "缓存写入 Token（5 分钟）",
    "cache_creation_1h_input_tokens": "缓存写入 Token（1 小时）",
    "cache_read_input_tokens": "缓存读取 Token",
    "input_utf8_bytes": "输入 UTF-8 字节",
    "provider_credits": "厂商积分",
    "web_search_requests": "联网搜索",
    "unitTokens": "Token",
    "unitBytes": "字节",
    "unitCredits": "积分",
    "input_token_tier": "输入 Token 档位",
    "audio": "音频",
    "video": "视频",
    "cached_input_tokens": "缓存输入",
    "cache_write_tokens": "缓存写入",
    "input_tokens": "输入 Token",
    "output_tokens": "输出 Token",
    "input_images": "图片输入",
    "output_images": "图片输出",
    "input_video_seconds": "输入视频",
    "output_video_seconds": "输出视频",
    "input_audio_seconds": "输入音频",
    "output_audio_seconds": "输出音频",
    "input_characters": "输入字符",
    "requests": "标准调用",
    "unitImages": "张",
    "unitSeconds": "秒",
    "unitCharacters": "字符",
    "unitRequests": "次",
    "videoOutputTokens": "视频生成输出 Token（厂商计费单位）",
    "perMillionVideoTokens": "每 1M 视频输出 Token",
    "videoGenerate": "视频生成",
    "imageGenerate": "图片生成",
    "audioGenerate": "音频生成",
    "general": "通用",
    "modality": "模态",
    "quality": "质量",
    "region_scope": "地域范围",
    "resolution": "分辨率",
    "size": "尺寸",
    "has_input_video": "输入视频",
    "inputVideoLongerThanOutput": "输入时长 > 输出时长",
    "inputVideoNotLongerThanOutput": "输入时长 ≤ 输出时长",
    "speed": "运行速度",
    "inference_geo": "节点地域",
    "global": "全球",
    "hd": "高清",
    "image": "图像",
    "non_global": "非全球",
    "standard": "标准",
    "fast": "快速",
    "text": "文本",
    "us": "美国节点",
    "eu": "欧洲节点",
    "tieredTitle": "定价与阶梯计费",
    "currencyLabel": "计费币种",
    "metricLabel": "计费项",
    "tierLabel": "条件 / 规格",
    "saleLabel": "销售价",
    "perUnit": "每 {{unit}}",
    "baseRate": "标准费率",
    "unpublished": "暂未发布售价"
  },
  "fields": {
    "element_name": "主体名称",
    "element_description": "主体描述",
    "reference_type": "主体素材类型",
    "element_image_list": "主体图片",
    "element_video_list": "主体视频",
    "element_voice_id": "关联音色 ID",
    "element_id": "主体 ID",
    "tag_list": "标签",
    "voice_name": "音色名称",
    "voice_url": "音频地址",
    "video_id": "来源视频 ID",
    "timestamp": "时间（秒）",
    "prompt": "提示词",
    "texts": "提示词",
    "text": "文本",
    "input": "输入",
    "instructions": "指令",
    "images": "参考图片",
    "image": "参考图片",
    "imageUrl": "参考图片",
    "imageTail": "尾帧图片",
    "modelH23TaskInput": "H23 任务参数",
    "modelH23FTaskInput": "H23F 任务参数",
    "modelP55TaskInput": "P5.5 任务参数",
    "headtailImages": "首尾帧",
    "headImage": "首帧",
    "tailImage": "尾帧",
    "negativePrompt": "负面提示词",
    "aspectRatio": "画面比例",
    "motionMode": "运动模式",
    "soundEffectSwitch": "音效",
    "generateAudioSwitch": "生成音频",
    "generateMultiClipSwitch": "多片段",
    "thinkingType": "提示词优化",
    "promptOptimizer": "提示词优化",
    "fastPretreatment": "快速预处理",
    "aigcWatermark": "AIGC 水印",
    "mask": "编辑蒙版",
    "videos": "视频",
    "video": "视频",
    "audios": "音频",
    "audio": "音频",
    "files": "文件",
    "duration": "时长",
    "resolution": "分辨率",
    "ratio": "画面比例",
    "aspect_ratio": "画面比例",
    "width": "宽度",
    "height": "高度",
    "seed": "随机种子",
    "voice_id": "音色",
    "voice": "音色",
    "speed": "语速",
    "language": "语言",
    "negative_prompt": "反向提示词",
    "with_audio": "生成音频",
    "generate_audio": "生成声音",
    "watermark": "水印",
    "temperature": "随机性",
    "thinking": "推理设置",
    "output_config": "输出配置",
    "top_k": "Top K",
    "stop_sequences": "停止序列",
    "top_p": "采样范围",
    "reasoning_effort": "推理强度",
    "max_output_tokens": "最大输出 Token",
    "response_format": "响应格式",
    "audio_format": "音频格式",
    "background": "背景",
    "channel": "声道",
    "contents": "内容",
    "content": "输入内容",
    "dimensions": "尺寸",
    "effort": "处理强度",
    "emotion": "情绪",
    "enable_prompt_cache": "启用提示词缓存",
    "enable_web_search": "启用网页搜索",
    "execution_expires_after": "任务过期时间",
    "function_calling_config": "函数调用配置",
    "generate_count": "生成数量",
    "hd": "高清模式",
    "image_detail": "图片细节",
    "instrumental": "纯音乐",
    "is_stream": "流式输出",
    "is_thinking": "启用思考",
    "layer_decomposition": "图片分层",
    "lyrics": "歌词",
    "lyrics_optimizer": "歌词优化",
    "max_tokens": "最大 Token 数",
    "moderation": "内容审核",
    "optimize_prompt_mode": "提示词优化模式",
    "output_compression": "输出压缩率",
    "output_format": "输出格式",
    "apply_text_normalization": "文本标准化",
    "result": "结果",
    "pitch": "音高",
    "previous_response_id": "上一次响应 ID",
    "priority": "任务优先级",
    "prompt_cache_key": "提示词缓存键",
    "quality": "质量",
    "reasoning_mode": "推理模式",
    "safety_identifier": "安全标识",
    "service_tier": "服务等级",
    "sparse_embedding": "稀疏向量",
    "store": "保存响应",
    "system": "系统指令",
    "thinking_level": "思考等级",
    "tool_config": "工具配置",
    "tools": "工具",
    "model": "模型 ID",
    "messages": "消息列表",
    "stream": "流式输出",
    "generationConfig": "生成设置",
    "systemInstruction": "系统指令",
    "thinkingConfig": "思考设置",
    "thinkingLevel": "思考等级",
    "includeThoughts": "返回思考内容",
    "maxOutputTokens": "最大输出 Token",
    "max_completion_tokens": "最大输出 Token",
    "tool_choice": "工具选择",
    "metadata": "附加信息",
    "url": "资源链接",
    "assetId": "平台资源 ID",
    "role": "用途",
    "embeddings": "向量",
    "data": "返回数据",
    "verbosity": "回答详略",
    "vol": "音量",
    "size": "输出尺寸",
    "n": "输出张数",
    "callback_url": "回调地址",
    "camera_motion": "镜头运动",
    "camera_fixed": "固定镜头",
    "parameters": "生成参数",
    "output": "生成结果"
  },
  "options": {
    "image_refer": "图片",
    "video_refer": "视频",
    "auto": "自动",
    "adaptive": "自动",
    "true": "是",
    "false": "否",
    "low": "低",
    "medium": "中",
    "high": "高",
    "xhigh": "超高",
    "none": "无",
    "default": "默认",
    "standard": "标准",
    "fast": "快速",
    "normal": "普通",
    "max": "最大",
    "png": "PNG",
    "jpeg": "JPEG",
    "webp": "WebP",
    "mp4": "MP4",
    "mov": "MOV",
    "transparent": "透明",
    "opaque": "不透明",
    "ratio_16_9": "横屏",
    "ratio_9_16": "竖屏",
    "ratio_1_1": "方形",
    "ratio_4_3": "4:3",
    "ratio_3_4": "3:4",
    "ratio_21_9": "21:9",
    "ratio_3_2": "3:2",
    "ratio_2_3": "2:3",
    "ratio_4_5": "4:5",
    "ratio_5_4": "5:4",
    "ratio_9_21": "9:21"
  },
  "roles": {
    "middle_frame": "中间帧",
    "keyframe": "片内关键帧",
    "prompt": "提示词",
    "negative_prompt": "负面提示词",
    "script": "脚本",
    "lyrics": "歌词",
    "source": "源素材",
    "mask": "蒙版",
    "control": "控制图",
    "voice_reference": "参考音色",
    "subject": "主体参考",
    "background": "背景参考",
    "edit": "编辑视频",
    "extend": "延长视频",
    "first_frame": "首帧",
    "last_frame": "尾帧",
    "reference_image": "参考图",
    "reference_video": "参考视频",
    "reference_audio": "参考音频",
    "input": "输入",
    "output": "输出",
    "intermediate": "中间结果",
    "preview": "预览",
    "thumbnail": "缩略图",
    "reference": "参考"
  },
  "workspace": {
    "resourceId": "资源 ID",
    "resourceReferenceHint": "填写当前渠道返回的资源 ID，并在提示词中使用 @引用名称。",
    "incompleteReference": "请填写 {{fields}}，或移除这条引用。",
    "resource_element": "主体引用",
    "resource_voice": "音色引用",
    "referenceName": "引用名称",
    "partSource": "地址",
    "partMoveUp": "上移内容",
    "partMoveDown": "下移内容",
    "partRemove": "删除内容",
    "viewOutputs": "查看全部 {{count}} 个输出 →",
    "run": "运行",
    "running": "运行中…",
    "reset": "重置",
    "cancel": "取消",
    "save": "保存",
    "close": "关闭",
    "copy": "复制",
    "copied": "已复制",
    "refresh": "刷新",
    "roleUnspecified": "不指定（按上游规则）",
    "retry": "重试",
    "search": "搜索",
    "clear": "清空",
    "add": "添加",
    "remove": "删除",
    "edit": "编辑",
    "maintain": "维护",
    "done": "完成",
    "previous": "上一页",
    "next": "下一页",
    "optional": "可选",
    "optionalZh": "可选",
    "confirm": "确定",
    "now": "现在",
    "clearValue": "清除",
    "refreshList": "刷新列表",
    "closeToast": "关闭通知",
    "input": "输入",
    "output": "结果",
    "preview": "预览",
    "form": "表单",
    "inputJson": "输入 JSON",
    "inputMode": "输入模式",
    "resultView": "结果视图",
    "moreSettings": "更多设置",
    "restore": "恢复默认",
    "loadingParameters": "正在加载参数…",
    "loadingModelParameters": "正在加载模型参数…",
    "loadingModel": "正在加载模型…",
    "loadingEndpoint": "正在加载端点参数…",
    "runResults": "运行结果",
    "textResults": "文本结果",
    "title": "体验",
    "operation": "操作类型",
    "selectModels": "选择模型",
    "addModel": "添加模型",
    "loginToRun": "登录后可运行",
    "repetitions": "每个模型的输出数量",
    "searchResults": "搜索运行结果",
    "searchGenerations": "生成记录…",
    "searchText": "文本请求…",
    "clearSearch": "清除搜索",
    "runStatus": "运行状态",
    "allStatus": "全部状态",
    "noText": "暂无文本请求",
    "noRuns": "暂无运行记录",
    "noMatches": "没有匹配的运行记录",
    "emptyText": "在左侧选择文本模型并输入提示词，点击「运行」即可创建专属多模型对比卡片。",
    "runCard": "运行卡片",
    "copyPrompt": "复制提示词",
    "copyAnswer": "复制回答",
    "copyReply": "复制回复",
    "submitting": "正在提交",
    "requestFailed": "请求失败",
    "runFailed": "调用失败",
    "waiting": "等待运行",
    "totalCost": "总费用",
    "total": "总计",
    "duration": "耗时",
    "cost": "费用",
    "status": "状态",
    "time": "时间",
    "tools": "工具",
    "toolsMulti": "工具（可多选）",
    "toolsUnavailable": "当前端点不支持",
    "ping": "连通测试",
    "toolCall": "模型工具调用",
    "toolResult": "Nexra 工具结果",
    "rawResponse": "原始响应",
    "toolArgs": "调用参数",
    "toolReturn": "工具返回",
    "images": "图片",
    "videos": "视频",
    "audios": "音频",
    "upload": "上传",
    "prompt": "提示词",
    "loading": "加载中…",
    "all": "全部",
    "models": "模型",
    "channel": "渠道",
    "provider": "提供商",
    "protocol": "端点协议",
    "inputContent": "输入内容",
    "role": "素材用途",
    "params": "请求参数",
    "responseParams": "返回参数",
    "apiKeys": "API 密钥",
    "requests": "请求记录",
    "admin": "管理后台",
    "account": "账号",
    "settings": "设置",
    "usage": "用量",
    "logout": "退出登录",
    "name": "名称",
    "createTime": "创建时间",
    "startTime": "开始时间",
    "endTime": "完成时间",
    "callback": "回调",
    "error": "错误",
    "enabled": "启用",
    "featured": "精选",
    "public": "公开",
    "modelInfo": "基本信息",
    "protocols": "协议与参数",
    "prices": "价格与计费",
    "routes": "渠道与路由",
    "currency": "币种",
    "description": "详细说明",
    "summary": "摘要",
    "displayName": "显示名称",
    "developer": "开发者",
    "aliases": "公开别名",
    "visibility": "可见范围",
    "modelState": "模型状态",
    "publishedVersion": "发布版本",
    "inputOutput": "输入与输出参数",
    "requestHeaders": "请求头",
    "requestBody": "请求体",
    "pathParams": "路径参数",
    "queryParams": "查询参数",
    "requestExample": "请求示例",
    "responseExample": "响应示例",
    "noRequestBody": "无需请求体。",
    "schemaJson": "参数 JSON 源码",
    "modelParams": "模型参数",
    "fieldDefault": "默认",
    "viewAll": "查看全部",
    "openOriginal": "打开原始文件 ↗",
    "copyJson": "复制 JSON",
    "example": "示例",
    "examplesNone": "暂无示例",
    "examplesNoneDetail": "当前版本暂未发布示例。",
    "loadingRequest": "正在执行请求…",
    "noModel": "模型不存在",
    "selectPlaceholder": "请选择",
    "selectPlaceholderDots": "请选择...",
    "apiDocs": "API 文档",
    "price": "价格",
    "history": "调用记录",
    "date": "日期",
    "defaultHint": "默认 default",
    "query": "查询",
    "filter": "筛选",
    "resetFilters": "重置筛选",
    "expandFilters": "展开",
    "collapseFilters": "收起",
    "loadingChannels": "正在加载渠道数据…",
    "noPage": "管理页面不存在",
    "deleted": "已删除",
    "noData": "暂无数据",
    "copyId": "复制 ID",
    "copyCode": "复制代码",
    "startGeneration": "开始生成",
    "generating": "生成中…",
    "closeSearch": "清空输入",
    "emptyMenu": "没有匹配的菜单",
    "loadingListError": "列表加载失败，请重试。",
    "noOptions": "没有匹配项，请调整搜索。",
    "scrollUp": "向上滚动选项",
    "scrollDown": "向下滚动选项",
    "uploaded": "素材上传中…",
    "costUnknown": "费用未知",
    "requestId": "请求 ID",
    "taskId": "任务 ID",
    "noRequests": "暂无请求记录",
    "searchRequests": "搜索请求记录",
    "loadingMore": "加载更多模型记录",
    "loadingStats": "加载更多统计样本",
    "originalFile": "在新标签页查看原始文件",
    "newRequest": "发送请求",
    "submitTask": "提交任务",
    "taskLifecycle": "任务生命周期",
    "files": "文件",
    "client": "客户端配置",
    "toc": "本页目录",
    "dateSnapshot": "日期快照",
    "requestResponse": "请求与返回参数",
    "language": "示例语言",
    "apiCall": "API 调用",
    "snapshots": "日期快照版本",
    "useExample": "在体验页打开",
    "requestLayout": "请求布局",
    "refreshData": "刷新数据",
    "filterType": "类型筛选",
    "noMatchingRequests": "未找到匹配的请求",
    "searchRequestsHint": "请求 ID、模型、提示词、终端用户或来源/IP…",
    "searchRuns": "搜索运行记录",
    "noRunRecords": "没有运行记录",
    "noRunRecordsDetail": "请在体验页面发起运行，或调整筛选条件。",
    "signIn": "登录控制台",
    "needSignIn": "请先登录",
    "progress": "进度",
    "completed": "成功 (OK)",
    "recommended": "推荐",
    "action": "操作",
    "modelPool": "渠道供给与路由",
    "queryResponse": "查询响应",
    "resultContent": "生成结果",
    "messageList": "消息列表",
    "generationParams": "生成参数",
    "comboLimits": "组合限制",
    "loadingPricing": "正在加载定价策略…",
    "enable": "是否启用",
    "costPrice": "成本价",
    "priority": "权重",
    "main": "主线路",
    "endpoint": "公开端点",
    "noEndpoint": "暂无公开端点",
    "lifecycle": "生命周期",
    "modelType": "模型类型",
    "connection": "接入状态",
    "channelStatus": "渠道状态",
    "currentModel": "当前模型",
    "availableModels": "可用模型",
    "recentErrors": "近期错误",
    "basicInfo": "基础信息",
    "pricingRules": "计费规则",
    "billingUnit": "计价单位",
    "unitPrice": "单价",
    "condition": "条件",
    "dimensions": "维度",
    "value": "值",
    "copyMarkdown": "复制 Markdown",
    "requestDetails": "请求详情",
    "characterCount": "{{count}} 字符",
    "promptPlaceholder": "输入提示词…",
    "shortcut": "快捷键",
    "collapse": "收起",
    "send": "发送",
    "dateTimeInvalid": "请输入有效时间，格式为 YYYY-MM-DD HH:mm",
    "selectDate": "选择{{label}}",
    "dateCalendar": "{{label}}日历",
    "hours": "小时",
    "minutes": "分钟",
    "part_text": "文本",
    "part_image": "图片",
    "part_video": "视频",
    "part_audio": "音频",
    "part_draft_task": "样片任务",
    "partOrderHint": "按顺序添加输入内容，可使用箭头调整顺序。",
    "partRoleOrderHint": "按顺序添加输入内容，可调整顺序和素材用途。",
    "partArrayHint": "content 必须是数组，请在 JSON 中修改。",
    "partUnsupportedHint": "此内容类型请在 JSON 中编辑。",
    "partTextLabel": "文本内容 {{index}}",
    "partTextPlaceholder": "描述画面、动作与声音…",
    "partEditTextPlaceholder": "填写提示词或编辑要求…",
    "partSourceLabel": "素材地址",
    "partOther": "其他内容",
    "partMediaHint": "支持公开 URL、完整 data: Base64 地址或上游素材地址。"
  },
  "sandbox": {
    "inputMediaTooLarge": "通过 HTTP 链接上传的视频不能超过 {{maxMb}} MB。请压缩视频，或使用受支持的 Google Cloud Storage URI。",
    "randomModel": "随机选择模型",
    "searchOperations": "搜索操作",
    "category": "模型类别",
    "operation": "操作类型",
    "noOperations": "没有匹配的操作",
    "modelCount": "{{count}} 个可运行模型",
    "selectedCount": "已选 {{count}} 个",
    "runSummary": "{{models}} 个模型 × {{repetitions}} 次",
    "searchModels": "搜索{{category}}模型",
    "noModels": "没有匹配的{{category}}模型",
    "noAvailableModels": "暂无可体验的模型",
    "chooseModel": "添加模型后填写参数",
    "maxModels": "最多 {{count}} 个模型",
    "browseModels": "浏览模型目录",
    "removeModel": "移除 {{model}}",
    "toolsCount": "已启用 {{count}} 个",
    "pingTag": "连通测试",
    "pingDescription": "通过回显工具验证工具调用链路",
    "builtinTool": "内置工具",
    "builtinToolDescription": "提供工具定义以启用工具调用",
    "singleHistory": "历史单次请求记录（{{count}}）",
    "changeFilters": "请更换搜索词或状态筛选。",
    "textCategory": "文本",
    "backToMediaLibrary": "返回作品总览",
    "loadingOlderCreations": "正在加载更早记录…",
    "retryMediaHistory": "重试加载历史",
    "loadOlderCreations": "加载更早记录",
    "allMediaHistoryLoaded": "{{category}}历史已全部加载",
    "audioDuration": "音频时长",
    "durationNotRecorded": "时长未记录",
    "noReferenceInput": "当前操作没有参考素材输入，可直接填写创作内容。",
    "videoWelcomeTitle": "让想象，开始流动",
    "videoWelcomeDescription": "描述画面、动作与声音，让灵感成为视频。",
    "backToCreation": "返回当前创作",
    "backToVideoLibrary": "返回作品总览",
    "promptAndSettings": "提示词与完整设置",
    "loadOlderVideos": "加载更早记录",
    "loadingOlderVideos": "正在加载更早记录…",
    "retryVideoHistory": "重试加载历史",
    "allVideoHistoryLoaded": "视频历史已全部加载",
    "horizontalHistoryHint": "横向浏览记录；当前会话结果优先，历史记录仅供查看。",
    "previousCreation": "向左浏览创作记录",
    "nextCreation": "向右浏览创作记录",
    "mediaRequestGroup": "创作记录：{{title}}",
    "currentSessionResult": "当前会话",
    "historyRecord": "历史记录",
    "createFromHistory": "基于此记录创作",
    "historyCreationTitle": "基于这份记录开始创作？",
    "historyCreationDescription": "这是一份已有记录。确认后会用该记录的提示词、原输入素材、模型和参数替换当前草稿；不会自动将生成结果作为参考素材，也不会立即发送请求。点击生成后将创建独立任务，并可能产生新的费用，原记录保持不变。",
    "historyCreationConfirm": "确认并载入设置",
    "modelSpecificParametersHint": "多选模型时使用共同支持的参数。以下专属参数或可选范围，需单独选择对应模型后设置。",
    "configureSingleModel": "单独选择该模型并设置",
    "mediaWorkspaceTitle": "{{category}}创作",
    "mediaLibrary": "历史作品",
    "viewNamedConversation": "查看对话：{{title}}",
    "backToConversationHistory": "返回历史对话",
    "backToCurrentConversation": "返回当前对话",
    "conversationHistory": "历史对话",
    "newShort": "新建",
    "backToCreationShort": "返回创作",
    "currentCreations": "本次创作",
    "previewCreation": "预览作品",
    "previewNamedCreation": "预览作品：{{title}}",
    "reuseSettings": "复用设置",
    "previewKeepsDraft": "预览不会更改当前草稿。选择“复用设置”后，可在下方修改并重新生成。",
    "replaceDraftTitle": "载入这份创作设置？",
    "replaceDraftDescription": "当前输入区已有未发送的内容或自定义设置。载入后会替换提示词、原输入素材、模型和参数；已生成的作品会保留。",
    "replaceDraftConfirm": "替换草稿并载入",
    "noMediaHistory": "还没有{{category}}作品",
    "mediaLibraryEmptyHint": "在下方输入创作要求；已有作品会显示在这里，可预览或复用设置。",
    "outputCount": "{{count}} 个结果",
    "newGeneration": "新创作",
    "untitledGeneration": "未命名创作",
    "mediaWelcome": {
      "image": "今天想创作什么画面？",
      "video": "今天想创作什么视频？",
      "audio": "今天想创作什么声音？"
    },
    "mediaWelcomeDescription": "选择操作和模型，填写内容，开始创作。",
    "mediaPrompt": {
      "image": "描述你想生成的画面，或说明图片修改要求…",
      "video": "描述画面、动作和声音，按需添加参考素材…",
      "audio": "输入朗读文案，或描述你想生成的音乐、音效…"
    },
    "readingGeneration": "正在查看历史创作",
    "generateFromRecord": "用这些设置再生成",
    "mediaRunSummary": "{{count}} 个模型 × {{repetitions}} 次",
    "outputNumber": "输出 {{count}}",
    "untitledConversation": "未命名对话",
    "historyDay": {
      "today": "今天",
      "yesterday": "昨天",
      "earlier": "更早"
    },
    "historyRounds": "{{count}} 轮对话",
    "historySingleRequest": "单次请求",
    "readingHistory": "正在查看历史对话",
    "resumeConversation": "继续这段对话",
    "startFromRecord": "基于此记录开始对话",
    "rawRecord": "原始请求与响应",
    "loadingSavedReply": "正在读取已保存的回答…",
    "savedReplyUnavailable": "暂时无法读取完整详情，请重新打开此记录。",
    "replyNotRecorded": "此记录未保存回答正文，可在请求详情中查看已记录的信息。",
    "replyUnrecognized": "这条记录包含响应数据，但未能提取可显示的文本，请查看原始响应。",
    "questionNotRecorded": "此记录未包含可识别的用户问题，请查看原始输入。",
    "showHistory": "展开历史侧栏",
    "hideHistory": "收起历史侧栏",
    "conversationList": "历史会话列表",
    "recentConversations": "最近对话",
    "parameterShortcut": "参数",
    "historyModelsUnavailable": "这段历史包含当前不可用的模型，请调整模型后开始新对话。",
    "addTextPart": "添加文本段",
    "editContentInJson": "此内容请通过“更多 → JSON”编辑。",
    "moreActions": "更多操作",
    "customParameters": "已自定义参数",
    "currentSession": "本次打开的对话",
    "welcomeTitle": "今天想聊些什么？",
    "welcomeDescription": "选择模型，写下问题，开始你的对话。",
    "promptPlaceholder": "写下问题，或告诉我你想完成什么…",
    "continuePlaceholder": "继续提问…",
    "chooseChatModel": "选择一个或多个模型，即可开始对话。",
    "checkParameters": "请检查参数设置中的输入格式。",
    "requestDetails": "请求详情",
    "backToConversation": "返回当前对话",
    "initialContext": "预置对话上下文（可选）",
    "toolsSettings": "工具设置",
    "historyComposerHint": "下方输入仍发送到当前对话",
    "historyReplyHint": "此记录内的追问仅延续这条历史对话。",
    "tokenDetailsHint": "点击查看完整 Token 与轮次详情",
    "newConversation": "新对话",
    "history": "历史",
    "parameters": "参数设置",
    "sharedInput": "公共输入",
    "sendToModels": "发送给 {{count}} 个模型",
    "followUpTarget": "追问对象",
    "followUpAll": "全部模型（{{count}}）",
    "followUpSelected": "本轮追问目标",
    "continueConversation": "继续当前对话",
    "singleConversation": "单模型对话",
    "send": "发送",
    "waitingResponse": "等待响应",
    "elapsedSeconds": "{{seconds}} 秒",
    "submittingTask": "正在发起任务",
    "queuedTask": "任务排队中",
    "generatingTask": "正在生成",
    "jsonInComposer": "在下方公共输入区编辑完整 JSON。",
    "emptyConversation": "在下方输入问题，开始单模型对话或多模型对比。",
    "contextPanel": "上下文",
    "hideContext": "收起上下文",
    "showContext": "展开上下文",
    "readingModel": "阅读模型：位置 {{slot}}",
    "manageModels": "参与模型",
    "generationBatch": "生成批次",
    "batchLabel": "第 {{count}} 批 · {{time}}",
    "sendTo": "本轮发送至",
    "targetHiddenLocate": "目标未展示 · 定位",
    "askThisModel": "追问此模型",
    "askModel": "追问 {{model}}",
    "expandPrompt": "展开全文",
    "collapsePrompt": "收起全文",
    "completedModels": "已完成",
    "cumulativeDuration": "累计模型用时",
    "hiddenTargetLabel": "未展示 · {{model}}"
  },
  "operations": {
    "video-depth": "视频深度提取",
    "video-segment": "视频目标分割",
    "image-upscale": "图片超分",
    "video-upscale": "视频超分",
    "voice-create": "保存音色",
    "voice-clone": "克隆音色",
    "language-generate": "文本生成",
    "image-generate": "图片生成",
    "video-generate": "视频生成",
    "audio-generate": "音频生成",
    "world-generate": "世界生成",
    "embedding-create": "向量生成",
    "text-to-image": "文生图",
    "image-to-image": "图生图",
    "edit-image": "图像编辑",
    "edit-multi-images": "多图编辑",
    "upscale": "超分放大",
    "remove-background": "去除背景",
    "avatar-video": "数字人视频",
    "multimodal-to-video": "全能参考",
    "text-to-video": "文生视频",
    "image-to-video": "首尾帧生成视频",
    "audio-to-video": "音频生视频",
    "video-to-video": "视频重绘",
    "text-to-speech": "语音合成",
    "text-to-music": "音乐生成",
    "text-to-sfx": "音效生成",
    "text-to-audio": "音效生成",
    "speech-to-text": "语音转文字",
    "text-to-world": "文生世界",
    "image-to-world": "图生世界",
    "video-to-world": "视频生世界",
    "text-to-text": "对话生成",
    "multimodal-to-text": "多模态对话"
  },
  "timing": {
    "invalidRecord": "耗时记录缺失或时间异常",
    "activeTask": "正在计时；自任务提交起计时，包含排队时间",
    "activeTaskAcceptance": "正在计时；自任务提交起计时，包含排队时间；接口受理耗时 {{duration}}",
    "taskAcceptance": "任务总耗时；接口受理耗时 {{duration}}{{missing}}",
    "unfinishedOrMissing": "；任务未结束或耗时记录缺失",
    "apiRequest": "接口请求耗时",
    "title": "用时统计",
    "liveLabel": "任务实时用时",
    "total": "总耗时",
    "deploymentCorrection": "结果就绪用时 {{service}}；部署额外延迟 {{delay}}。总耗时保留真实响应时间。",
    "request": "请求耗时",
    "prep": "提交准备",
    "gen": "模型生成",
    "stor": "结果存储",
    "stages": "{{count}} 阶段耗时",
    "responseOverhead": "其他处理/等待",
    "responseOverheadHint": "未单独分段记录；为首次响应与已记录阶段之间的差值。",
    "api": "接口调用",
    "queuedHint": "正在调度排队与任务预检…",
    "prepTask": "调度排队与任务预检",
    "prepApi": "网关鉴权与路由调度",
    "generatingHint": "模型核心推理流式生成中…",
    "genTask": "模型推理执行计算",
    "genApi": "模型推理流式响应",
    "storingHint": "媒体资产持久化入库中…",
    "storTask": "媒体资产持久化入库",
    "storApi": "日志落盘与扣费结算",
    "response": "响应",
    "firstResponse": "第一次响应",
    "secondResponse": "第二次响应",
    "incomplete": "分段记录缺失或时间顺序异常；总耗时按提交至完成计算",
    "liveDetail": "任务正在执行中，已用时：{{duration}}",
    "stageDetail": "{{stage}}：{{duration}}",
    "apiDetail": "接口请求耗时",
    "stageShare": "{{stage}} {{duration}} ({{percent}}%)"
  },
  "channelMapping": {
    "channelDisabled": "渠道已停用",
    "supplyDisabled": "供给已停用",
    "degraded": "渠道异常",
    "unavailable": "上游暂不可用",
    "active": "供给已启用"
  },
  "modelDelivery": {
    "help": "把上游渠道中的模型映射到本模型（渠道模型），并为每个公开端点配置供应线路（Route）：优先级、权重与状态。",
    "addSupply": "＋ 添加供给",
    "overview": "路由概览",
    "overviewHelp": "查看各渠道的协议覆盖，以及主备和权重配置。",
    "summary": "{{providers}} 个 Provider · {{supplies}} 份供给 · 当前协议 {{count}} 个可调度组合",
    "noCoverage": "（无可用覆盖）",
    "matrix": "端点覆盖矩阵",
    "supplies": "返回渠道列表"
  },
  "privateVoices": {
    "cloneTitle": "克隆私人音色",
    "samples": "音频样本",
    "sampleLimit": "选择 1–5 个音频文件，总大小不超过 25 MiB。",
    "slotPrice": "{{amount}}，音色有效期为 30 天。",
    "clone": "克隆音色",
    "cloning": "克隆中…",
    "cloneFailed": "无法克隆音色。"
  },
  "userUsage": {
    "description": "当前账户在所选时间范围内的全部调用与已结算消费，包含 API Key 和体验调用。按请求接收时间统计，日期按 UTC 分组。",
    "start": "开始时间",
    "end": "结束时间",
    "recentDays": "最近 {{count}} 天",
    "recentDays_one": "最近 {{count}} 天",
    "invalidRange": "请选择有效的开始和结束时间，单次查询不超过 31 天。",
    "allRequests": "包含所有调用，非抽样统计",
    "settledCharges": "已结算消费",
    "settledHint": "仅成功结算金额；已退款费用不计入",
    "noSettledCharges": "暂无已结算费用",
    "successHint": "成功请求占全部请求的比例",
    "unsettledHint": "已有用量但尚未完成结算的请求",
    "dayUtc": "日期（UTC）",
    "distributionHint": "所选时间范围内，各模型的完整请求数分布。"
  },
  "creativeHome": {
    "footer": {
      "creation": "创作与探索",
      "models": "模型分类",
      "developer": "开发者与账户",
      "about": "关于 Nexra",
      "audioModels": "音频模型",
      "usage": "用量统计"
    },
    "revealPhotos": {
      "cloud-city": "云上之城",
      "three-color-city": "三色城市",
      "icefield-moons": "冰原双月",
      "bionic-architecture": "仿生生态建筑",
      "cloud-goldfish": "云中金鱼",
      "inverted-salt-lake": "倒悬盐湖",
      "liquid-stars": "液态星空",
      "winter-forest": "冬季森林",
      "glass-city": "玻璃城市",
      "sunflower-observatory": "向日葵天文台",
      "underwater": "水下",
      "candy-shelves": "糖果货架",
      "inverted-sea": "倒悬之海",
      "alien-plants": "外星植物",
      "floating-island": "漂浮岛",
      "geometric-city": "几何未来城市",
      "van-gogh": "梵高",
      "mirror": "镜像",
      "strange-object": "奇怪的物体",
      "colorful-banana": "彩色香蕉",
      "crystal-spires": "晶体尖塔",
      "flowing-light-city": "流光城",
      "clay": "黏土",
      "flying-bookshop": "旧书店的起飞"
    },
    "galleries": {
      "videoEyebrow": "视频精选",
      "videoTitle": "镜头里的更多可能",
      "videoDescription": "产品广告、角色表现与风格短片，展开看见更多细节。",
      "pauseVideo": "暂停播放",
      "playVideo": "播放视频",
      "imageEyebrow": "图像灵感",
      "imageTitle": "一种创意，不止一种风格",
      "imageDescription": "从商业视觉到电影画面，从角色设定到鲜活人像，探索不同的表达。",
      "pauseWall": "暂停漂移",
      "playWall": "继续漂移",
      "wallHint": "点击查看完整图片",
      "modelsTitle": "让创意，连接更多模型",
      "modelsDescription": "通过 Nexra 探索视频、图像、语音与文本模型，为你的产品与创作找到合适的能力。",
      "videos": {
        "v9": {
          "title": "产品广告",
          "description": "材质、光影与镜头，让产品成为画面主角。"
        },
        "v13": {
          "title": "时间与运镜",
          "description": "定格动作，环绕视角，探索镜头的表现力。"
        },
        "v11": {
          "title": "角色登场",
          "description": "从角色造型到场景氛围，构建一次完整亮相。"
        },
        "v14": {
          "title": "潮流视觉",
          "description": "图形、角色与快节奏剪辑，释放视觉张力。"
        },
        "v16": {
          "title": "风格短片",
          "description": "鲜明色彩与动态构图，形成独特的视觉语言。"
        }
      },
      "images": {
        "p10": "时尚封面",
        "p30": "向阳人像",
        "p14": "霓虹动漫",
        "p24": "彩色漫画分镜",
        "p16": "产品破纸而出",
        "p27": "竹林电影场景",
        "p25-character": "角色设定与多视角",
        "p31": "草地上的瞬间",
        "p18": "饮料宣传",
        "p13": "雨夜动漫街景",
        "p26": "幻想电影场景",
        "p23": "潮流角色视觉",
        "p20": "暗黑奇幻世界",
        "p29": "街头人像",
        "p25-comic": "黑白漫画叙事",
        "p15": "街头派送",
        "p22-eastern": "东方山水意境",
        "p17": "餐饮宣传",
        "p28": "雪夜电影人像",
        "p22-pop": "紫色潮流视觉"
      }
    },
    "announcement": {
      "label": "Nexra 平台导览",
      "message": "从一个想法，走向更多创作可能。探索 Nexra 的视频、图像与文本能力。",
      "about": "了解平台",
      "contact": "联系合作"
    },
    "info": {
      "preparing": "内容筹备中",
      "back": "返回首页",
      "about": {
        "title": "了解 Nexra",
        "description": "这里将介绍 Nexra 的平台能力与使用方式，内容正在准备中。"
      },
      "contact": {
        "title": "联系合作",
        "description": "这里将提供商务合作与联系信息，内容正在准备中。"
      }
    },
    "playground": "体验",
    "modelSquare": "模型",
    "heroLabel": "首屏视频与创作介绍",
    "heroTitle": "让想象\n成为画面",
    "heroDescription": "视频、图像与文本，在此相遇\n从一个想法开始，探索创作的更多可能",
    "start": "开始创作",
    "discover": "探索作品",
    "videoTitle": "从产品短片到角色故事",
    "videoDescription": "用镜头展示产品，用动作塑造角色",
    "audioNote": "默认静音 · 点击启用声音，悬停聆听、移开静音 · Enter / 空格切换声音",
    "mediaError": "视频暂时无法播放，可刷新页面重试。",
    "imageRevealOpeningTitle": "看见更多\n创作可能",
    "imageRevealTitle": "让灵感\n跃然眼前",
    "imageTitle": "场景、设计与人物",
    "filterLabel": "筛选图片",
    "filters": {
      "all": "全部",
      "scene": "场景",
      "design": "设计",
      "portrait": "人物"
    },
    "groups": {
      "scene": {
        "title": "场景与空间"
      },
      "design": {
        "title": "海报与设计"
      },
      "portrait": {
        "title": "人物与风格"
      }
    },
    "viewImage": "查看「{{title}}」完整图片",
    "exploreText": "探索文本模型",
    "scriptLabel": "分镜草稿",
    "example": "示例内容",
    "scriptPrompt": "为一台便携相机设计一支 15 秒广告\n突出材质、镜头与轻便机身",
    "scriptAnswer": "0–5 秒 · 细节\n侧光扫过机身，镜头推进至金属纹理\n\n5–10 秒 · 转场\n穿过镜片，将玻璃反光衔接到水面涟漪\n\n10–15 秒 · 产品\n相机缓缓转向正面，定格完整机身",
    "modelTitle": "按创作类型探索模型",
    "models": {
      "video": {
        "title": "视频模型",
        "description": "运动、镜头与叙事"
      },
      "image": {
        "title": "图像模型",
        "description": "构图、风格与细节"
      },
      "language": {
        "title": "文本模型",
        "description": "理解、表达与构思"
      }
    },
    "ending": "开始你的下一次创作",
    "exploreCreate": "开始创作",
    "backTop": "回到顶部",
    "media": {
      "v1": {
        "title": "古殿中的故事",
        "type": "角色叙事 · V1",
        "alt": "古殿中的角色叙事视频"
      },
      "v2": {
        "title": "风暴中的想象",
        "type": "幻想世界 · V2",
        "alt": "风暴海面与幻想人物视频"
      },
      "v6": {
        "title": "光落下的瞬间",
        "type": "人物特写 · V6",
        "alt": "暖光中的人物特写视频"
      },
      "v4": {
        "title": "城市的另一面",
        "type": "人物特写 · V4",
        "alt": "城市夜景中的人物特写视频"
      },
      "v8": {
        "title": "跟随镜头",
        "type": "电影氛围 · V8",
        "alt": "暖光走廊中的人物叙事视频"
      },
      "v5": {
        "title": "动作与张力",
        "type": "动态场景 · V5",
        "alt": "动作场景与爆炸特效视频"
      },
      "v7": {
        "title": "换一个视角",
        "type": "人物表演 · V7",
        "alt": "仰视角度的人物表演视频"
      },
      "p5": {
        "title": "云端之城",
        "alt": "日落下的云端幻想城市，悬浮建筑与瀑布交织"
      },
      "p6": {
        "title": "暮色水城",
        "alt": "暮色中的水上城市，钟楼与灯光映在水面"
      },
      "v3": {
        "title": "追逐落日",
        "alt": "从赛车驾驶舱望向落日下的赛道"
      },
      "p1": {
        "title": "蓝色构成",
        "alt": "蓝白色几何图形与手部摄影组成的拼贴海报"
      },
      "p3": {
        "title": "认识自己",
        "alt": "黑白人物侧脸与认识自己文字构成的海报"
      },
      "p2": {
        "title": "数字肖像",
        "alt": "彩色数字故障方块构成的巨幅人物肖像"
      },
      "p4": {
        "title": "未来之光",
        "alt": "黑色背景下泛着彩色光泽的未来机械人物侧脸"
      },
      "p8": {
        "title": "日常片刻",
        "alt": "站在卧室中的女性，穿着白色印花家居服"
      },
      "p7": {
        "title": "复古未来",
        "alt": "人物、幻想生物与建筑拼贴而成的复古未来海报"
      },
      "p9": {
        "title": "山水入梦",
        "alt": "古风女性侧脸与山水楼阁相融合的淡蓝色双重曝光画面"
      },
      "v9": {
        "title": "产品广告",
        "alt": "相机机身、镜头与材质细节组成的产品广告视频"
      },
      "v10": {
        "title": "人物动作",
        "alt": "户外全身人物舞蹈竖屏视频"
      },
      "v11": {
        "title": "角色登场",
        "alt": "太极意象与风格化三维角色出场视频"
      },
      "v12": {
        "title": "产品显露",
        "alt": "手掌擦去玻璃水雾后显露产品的竖幅视频"
      },
      "v13": {
        "title": "时间凝结",
        "alt": "镜头环绕人物与悬浮瓶罐的时间静止视频"
      }
    },
    "exploreVideo": "探索视频模型",
    "exploreImage": "探索图像模型"
  }
}
